/* eslint-disable func-names */
/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Yup from 'yup';
import { iFormMetaData, iAttachments, iAddress, iContactMin, iSummary, iObligation } from '@interfaces/interfaces';
import { ProgressStep, FormType, ABN_MIN_LENGTH, ACN_MIN_LENGTH } from '@constants';
import { ADDRESS_FIELD_CHARS_REGEX, COMPANY_NAME_REGEX, CONTACT_NUMBER_REGEX, EMAIL_SPECIAL_CHARS_REGEX, FREE_TEXT_FIELD_REGEX, NAMES_FIELDS_REGEX, OBLIGATION_REGEX, POSITION_IN_COMPANY_REGEX, POST_CODE_REGEX, VEHICLE_REGISTRATION_REGEX } from '@services/ValidationRules';

import { FormikValues } from 'formik';
// import { INVALID_FILE_SIZE_ERROR_MESSAGE } from '@pages/forms/nomination/Step6/NominationStep6';
import { EMPTY_DATE, FILE_UPLOAD_FAIL, INVALID_ADDRESS_FIELD_ERROR, INVALID_COMPANY_NAME, INVALID_EMAIL, INVALID_FREE_TEXT_FIELD_FORMAT, INVALID_FUTURE_DATE, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION, INVALID_INPUT_LONGER_THAN_10_CHARS, INVALID_INPUT_LONGER_THAN_200_CHARS, INVALID_INPUT_LONGER_THAN_50_CHARS, INVALID_INPUT_LONGER_THAN_75_CHARS, INVALID_INPUT_LONGER_THAN_80_CHARS, INVALID_LICENCE_FORMAT_NOMINATION, INVALID_MOBILE_NUMBER_FORMAT, INVALID_NAME_FORMAT_NEW, INVALID_NUMERIC_FORMAT, INVALID_OBLIGATION_NUMBER, INVALID_OFFENCE_FIND_OUT_DATE, INVALID_PHONE_NUMBER, INVALID_PHONE_NUMBER_LENGTH, INVALID_POSITION_IN_COMPANY_FIELD, INVALID_POST_CODE_NOMINATION, INVALID_VEHICLE_REGISTRATION_NUMBER, INVALID_VEHICLE_REGISTRATION_NUMBER_LENGTH, INVALID_YESNO_FORMAT, MISSING_DECLARATION_AGREEMENT, INVALID_PHONE_NUMBER_LENGTH_15, INVALID_INPUT_LONGER_THAN_15_CHARS, INVALID_ACN, INVALID_ABN, INVALID_INPUT_LONGER_THAN_25_CHARS, INVALID_NUMBER_INPUT } from './ErrorMessages';
import keys from './PageValidationKeys';

const { NOMINATION } = FormType;

const today = new Date();

export interface iPartialFormData {
  a: string;
  submitted: boolean;
  InfringementNoticeNumber: string;
  // Step1 Field
  OBLIGATION_NUMBER: string;
  // Step2 Fields
  OFFENCE_DATE: Date | null;
  HEARING_DATE: Date | null;
  VEHICLE_REGISTRATION: string;
  DRIVER_LICENCE: string;
  DOB: Date | null;
  // Step 3 fields
  SaveYesNo: string;
  SaveOptions: string;
  saveEmail: string;
  saveMobile: string;

  // Step 4
  isThePersonNamed: string;
  Status: string;
  DebtorType: string;
  isDebtorTypeIndividual: boolean;
  // Step 5
  SelectedGroundInfo: string,
  FineStage: string,
  HasBeenNominatedBefore: boolean,
  OffenceType: string,
  IsMarineOffence: boolean,
  IsTsvOffence: boolean,
  IsSeriousOffence: boolean,
  selectTheOption: string;
  closeTheOption: string;
  // Step 6 someone else
  WhoAreYouNominating: string;
  // person details
  GivenNamesSomeoneElse: string;
  FamilyNameSomeoneElse: string;
  DOBSomeoneElse: Date | null;
  DOBYesNoSomeoneElse: boolean;
  DriverLicenseSomeoneElse: string;
  LicenceStateSomeoneElse: string;
  StatecountryOfIssueSomeoneElse: string;
  NoDriverLicenseSomeoneElse: boolean;
  TaxDriverAccNumber: string;
  ResidentialAddressSomeoneElse: iAddress;
  NoResidentialAddressSomeoneElse: string;
  NoEmailSomeoneElse: string;
  EmailSomeoneElse: string;
  IndividualContactNumberSomeoneElse: iContactMin;
  NoContactNumberSomeoneElse: string;
  EmailSomeoneElseWarning: string;
  IndividualContactNumberSomeoneElseWarning: string;
  // company details
  CompanyNameSomeoneElse: string;
  AbnacnTypeSomeoneElse: string;
  AcnNoSomeoneElse: string;
  isACNValidSomeoneElse: boolean;
  NoOrgContactNumberSomeoneElse: boolean;
  AbnNoSomeoneElse: string;
  isABNValidSomeoneElse: boolean;
  CompanyStreetAddressSomeoneElse: iAddress;
  OrganisationContactNumberSomeoneElse: iContactMin;
  CompanyEmailSomeOneElse: string;
  CompanyEmailYesNoSomeOneElse: boolean;
  CompanyEmailSomeOneElseWarning: string;
  OrganisationContactNumberSomeoneElseWarning: string;

  // Step 7
  TransferedVicRoads: string;
  DateSellOrDispose: Date | null;
  EvidenceSoldOrDispose: iAttachments[];
  EvidenceSoldOrDisposeNameField: string;
  EvidenceSoldOrDisposeProvider: string;
  EvidenceSoldOrDisposeFilesDescription: string;
  EvidenceSoldOrDisposeErrorHandle: boolean;
  EvidenceSoldOrDisposeSizeErrorHandle: boolean;
  EvidenceSoldOrDisposeFileUploadErrorHandle: boolean;
  EvidenceSoldOrDisposeFileSectionError: string;
  WhoAreYouNominatingSoldDispose: string;
  // step 7 person
  GivenNamesSoldDisposed: string;
  FamilyNameSoldDisposed: string;
  DOBSoldDisposed: Date | null;
  DOBYesNoSoldDisposed: boolean;
  DriverLicenseSoldDisposed: string;
  LicenceStateSoldDisposed: string;
  StatecountryOfIssueSoldDisposed: string;
  NoDriverLicenseSoldDisposed: boolean;
  ResidentialAddressSoldDisposed: iAddress;
  NoEmailSoldDisposed: string;
  EmailSoldDisposed: string;
  IndividualContactNumberSoldDisposed: iContactMin;
  NoContactNumberSoldDisposed: string;
  EmailSoldDisposedWarning: string;
  IndividualContactNumberSoldDisposedWarning: string;
  // step 7 Company
  CompanyNameSoldDisposed: string;
  AbnacnTypeSoldDisposed: string;
  AcnNoSoldDisposed: string;
  isACNValidSoldDisposed: boolean;
  OrganisationContactNumberYesNoSoldDisposed: string;
  AbnNoSoldDisposed: string;
  isABNValidSoldDisposed: boolean;
  CompanyStreetAddressSoldDisposed: iAddress;
  OrganisationContactNumberSoldDisposed: iContactMin;
  NoOrgContactNumberSoldDisposed: boolean;
  CompanyEmailSoldDisposed: string;
  CompanyEmailYesNoSoldDisposed: string;
  CompanyEmailSoldDisposedWarning: string;
  OrganisationContactNumberSoldDisposedWarning: string;
  // Step 8
  VictoriaPoliceReferenceNumber: string;

  VehicleOrIdentificationStolenOrFalse: iAttachments[];
  VehicleOrIdentificationStolenOrFalseNameField: string;
  VehicleOrIdentificationStolenOrFalseProvider: string;
  VehicleOrIdentificationStolenOrFalseDescription: string;
  VehicleOrIdentificationStolenOrFalseErrorHandle: boolean;
  VehicleOrIdentificationStolenOrFalseSizeErrorHandle: boolean;
  VehicleOrIdentificationStolenOrFalseFileUploadErrorHandle: boolean;
  VehicleOrIdentificationStolenOrFalseFileSectionError: string;

  // Step 9
  IncorrectNominationExplanation: string;

  RejectionSupportingDocs: iAttachments[];
  RejectionSupportingDocsNameField: string;
  RejectionSupportingDocsProvider: string;
  RejectionSupportingDocsDescription: string;
  RejectionSupportingDocsErrorHandle: boolean;
  RejectionSupportingDocsSizeErrorHandle: boolean;
  RejectionSupportingDocsFileUploadErrorHandle: boolean;
  RejectionSupportingDocsFileSectionError: string;

  // Step 10
  UnableToIdentifyExplanation: string;

  UnableToIdentify: iAttachments[];
  UnableToIdentifyNameField: string;
  UnableToIdentifyProvider: string;
  UnableToIdentifyDescription: string;
  UnableToIdentifyErrorHandle: boolean;
  UnableToIdentifySizeErrorHandle: boolean;
  UnableToIdentifyFileUploadErrorHandle: boolean;
  UnableToIdentifyFileSectionError: string;
  // Step 11
  // person
  GivenNamesYourDetails: string;
  FamilyNameYourDetails: string;
  DOBYourDetails: Date | null;
  DriverLicenseYourDetails: string;
  LicenceStateYourDetails: string;
  StatecountryOfIssueYourDetails: string;
  NoDriverLicenseYourDetails: string;
  IndividualPostalAddressYourDetails: iAddress;
  DifferentToPostalYourDetails: string;
  ResidentialAddressYourDetails: iAddress;
  NoEmailYourDetails: string;
  EmailYourDetails: string;
  IndividualContactNumberYourDetails: iContactMin;
  NoContactNumberYourDetails: string;
  EmailYourDetailsWarning: string;
  IndividualContactNumberYourDetailsWarning: string;
  // company
  GivenNamesYourDetailsCompany: string;
  FamilyNameYourDetailsCompany: string;
  PositionInCompanyYourDetailsCompany: string;
  OrganisationContactNumberYourDetailsCompany: iContactMin;
  NoOrgContactNumberYourDetails: string;
  CompanyEmailYourDetails: string;
  CompanyEmailYesNoYourDetails: string;
  CompanyNameYourDetailsCompany: string;
  AbnacnTypeYourDetails: string;
  AcnNoYourDetails: string;
  isACNValidYourDetails: boolean;
  OrganisationContactNumberYesNoYourDetails: string;
  AbnNoYourDetails: string;
  isABNValidYourDetails: boolean;
  CompanyStreetAddressYourDetails: iAddress;
  DifferentToStreetAddressYourDetails: string;
  CompanyPostalAddressYourDetails: iAddress;
  CompanyEmailYourDetailsWarning: string;
  OrganisationContactNumberYourDetailsCompanyWarning: string;
  // Step 12
  CheckAndConfirmPageLoaded: boolean;
  // Step 14
  nominationConsentToDeclaration: boolean;
}
interface iPartialFormObligations {
  ID: number;
  ObligationNO: string;
  IsPrimary: boolean;
}
export interface iCommonNominationValues {
  [key: string]: string | Date | boolean | null | iAttachments[] | iPartialFormData | iPartialFormObligations[] | number | iAddress | iContactMin | iObligation | iObligation[];
  OBLIGATION_NUMBER: string;
  isOfficerIssued: boolean | null;
  // Step 2
  OFFENCE_DATE: Date | null;
  HEARING_DATE: Date | null;
  VEHICLE_REGISTRATION: string;
  DRIVER_LICENCE: string;
  DOB: Date | null;
  // Step 3 fields
  SaveYesNo: string;
  SaveOptions: string;
  saveEmail: string;
  saveMobile: string;
  IsSubscribedEM: boolean;
  IsSubscribedSMS: boolean;
  EMRemeinderSent: boolean;
  SMSRemeinderSent: boolean;
  // Step 4
  isThePersonNamed: string;
  Status: string;
  DebtorType: string;
  isDebtorTypeIndividual: boolean;
  // Partial Forms
  ID: string;
  PartialFormID: string;
  FormData: iPartialFormData;
  Obligations: iPartialFormObligations[];
}

export interface iNominationFormValues extends iCommonNominationValues {
  InfringementNumber: string;
  InfringementNoticeNumber: string;
  DebtorId: number;
  isDebtorTypeIndividual: boolean;
  alreadySavedForm: boolean;
  // Step 5
  SelectedGroundInfo: string,
  FineStage: string,
  HasBeenNominatedBefore: boolean,
  OffenceType: string,
  IsMarineOffence: boolean,
  IsTsvOffence: boolean,
  IsSeriousOffence: boolean,
  selectTheOption: string;
  closeTheOption: string;
  // Step 6 someone else
  WhoAreYouNominating: string;
  // person details
  GivenNamesSomeoneElse: string;
  FamilyNameSomeoneElse: string;
  DOBSomeoneElse: Date | null;
  DOBYesNoSomeoneElse: boolean;
  DriverLicenseSomeoneElse: string;
  LicenceStateSomeoneElse: string;
  StatecountryOfIssueSomeoneElse: string;
  NoDriverLicenseSomeoneElse: boolean;
  TaxDriverAccNumber: string;
  ResidentialAddressSomeoneElse: iAddress;
  NoResidentialAddressSomeoneElse: string;
  NoEmailSomeoneElse: string;
  EmailSomeoneElse: string;
  IndividualContactNumberSomeoneElse: iContactMin;
  NoContactNumberSomeoneElse: string;
  EmailSomeoneElseWarning: string;
  IndividualContactNumberSomeoneElseWarning: string;
  // company details
  CompanyNameSomeoneElse: string;
  AbnacnTypeSomeoneElse: string;
  AcnNoSomeoneElse: string;
  isACNValidSomeoneElse: boolean;
  NoOrgContactNumberSomeoneElse: boolean;
  AbnNoSomeoneElse: string;
  isABNValidSomeoneElse: boolean;
  CompanyStreetAddressSomeoneElse: iAddress;
  OrganisationContactNumberSomeoneElse: iContactMin;
  CompanyEmailSomeOneElse: string;
  CompanyEmailYesNoSomeOneElse: boolean;
  CompanyEmailSomeOneElseWarning: string;
  OrganisationContactNumberSomeoneElseWarning: string;

  // Step 7
  TransferedVicRoads: string;
  DateSellOrDispose: Date | null;
  FileUploadSizeConfig: number;
  FileUploadDescriptionConfig: string;
  FileUploadMaxAttachmentsConfig: number;
  EvidenceSoldOrDispose: iAttachments[];
  EvidenceSoldOrDisposeNameField: string;
  EvidenceSoldOrDisposeProvider: string;
  EvidenceSoldOrDisposeFilesDescription: string;
  EvidenceSoldOrDisposeErrorHandle: boolean;
  EvidenceSoldOrDisposeSizeErrorHandle: boolean;
  EvidenceSoldOrDisposeFileUploadErrorHandle: boolean;
  EvidenceSoldOrDisposeFileSectionError: string;
  // step 7 person
  WhoAreYouNominatingSoldDispose: string;
  GivenNamesSoldDisposed: string;
  FamilyNameSoldDisposed: string;
  DOBSoldDisposed: Date | null;
  DOBYesNoSoldDisposed: boolean;
  DriverLicenseSoldDisposed: string;
  LicenceStateSoldDisposed: string;
  StatecountryOfIssueSoldDisposed: string;
  NoDriverLicenseSoldDisposed: boolean;
  ResidentialAddressSoldDisposed: iAddress;
  NoEmailSoldDisposed: string;
  EmailSoldDisposed: string;
  IndividualContactNumberSoldDisposed: iContactMin;
  EmailSoldDisposedWarning: string;
  IndividualContactNumberSoldDisposedWarning: string;
  NoContactNumberSoldDisposed: string;
  // step 7 Company
  CompanyNameSoldDisposed: string;
  AbnacnTypeSoldDisposed: string;
  AcnNoSoldDisposed: string;
  isACNValidSoldDisposed: boolean;
  OrganisationContactNumberYesNoSoldDisposed: string;
  AbnNoSoldDisposed: string;
  isABNValidSoldDisposed: boolean;
  CompanyStreetAddressSoldDisposed: iAddress;
  OrganisationContactNumberSoldDisposed: iContactMin;
  NoOrgContactNumberSoldDisposed: boolean;
  CompanyEmailSoldDisposed: string;
  CompanyEmailYesNoSoldDisposed: string;
  CompanyEmailSoldDisposedWarning: string;
  OrganisationContactNumberSoldDisposedWarning: string;

  // Step 8
  VictoriaPoliceReferenceNumber: string;
  VehicleOrIdentificationStolenOrFalse: iAttachments[];
  VehicleOrIdentificationStolenOrFalseNameField: string;
  VehicleOrIdentificationStolenOrFalseProvider: string;
  VehicleOrIdentificationStolenOrFalseDescription: string;
  VehicleOrIdentificationStolenOrFalseErrorHandle: boolean;
  VehicleOrIdentificationStolenOrFalseSizeErrorHandle: boolean;
  VehicleOrIdentificationStolenOrFalseFileUploadErrorHandle: boolean;
  VehicleOrIdentificationStolenOrFalseFileSectionError: string;

  // Step 9
  IncorrectNominationExplanation: string;

  RejectionSupportingDocs: iAttachments[];
  RejectionSupportingDocsNameField: string;
  RejectionSupportingDocsProvider: string;
  RejectionSupportingDocsDescription: string;
  RejectionSupportingDocsErrorHandle: boolean;
  RejectionSupportingDocsSizeErrorHandle: boolean;
  RejectionSupportingDocsFileUploadErrorHandle: boolean;
  RejectionSupportingDocsFileSectionError: string;

  // Step 10
  UnableToIdentifyExplanation: string;

  UnableToIdentify: iAttachments[];
  UnableToIdentifyNameField: string;
  UnableToIdentifyProvider: string;
  UnableToIdentifyDescription: string;
  UnableToIdentifyErrorHandle: boolean;
  UnableToIdentifySizeErrorHandle: boolean;
  UnableToIdentifyFileUploadErrorHandle: boolean;
  UnableToIdentifyFileSectionError: string;
  // Step 11
  // person
  GivenNamesYourDetails: string;
  FamilyNameYourDetails: string;
  DOBYourDetails: Date | null;
  DriverLicenseYourDetails: string;
  LicenceStateYourDetails: string;
  StatecountryOfIssueYourDetails: string;
  NoDriverLicenseYourDetails: string;
  IndividualPostalAddressYourDetails: iAddress;
  DifferentToPostalYourDetails: string;
  ResidentialAddressYourDetails: iAddress;
  NoEmailYourDetails: string;
  EmailYourDetails: string;
  IndividualContactNumberYourDetails: iContactMin;
  NoContactNumberYourDetails: string;
  EmailYourDetailsWarning: string;
  IndividualContactNumberYourDetailsWarning: string;
  // company
  GivenNamesYourDetailsCompany: string;
  FamilyNameYourDetailsCompany: string;
  PositionInCompanyYourDetailsCompany: string;
  OrganisationContactNumberYourDetailsCompany: iContactMin;
  NoOrgContactNumberYourDetails: string;
  CompanyEmailYourDetails: string;
  CompanyEmailYesNoYourDetails: string;
  CompanyNameYourDetailsCompany: string;
  AbnacnTypeYourDetails: string;
  AcnNoYourDetails: string;
  isACNValidYourDetails: boolean;
  OrganisationContactNumberYesNoYourDetails: string;
  AbnNoYourDetails: string;
  isABNValidYourDetails: boolean;
  CompanyStreetAddressYourDetails: iAddress;
  DifferentToStreetAddressYourDetails: string;
  CompanyPostalAddressYourDetails: iAddress;
  CompanyEmailYourDetailsWarning: string;
  OrganisationContactNumberYourDetailsCompanyWarning: string;
  // Step 12
  CheckAndConfirmPageLoaded: boolean;
  // Step 14
  nominationConsentToDeclaration: boolean;

  // Submission
  submissionNo: string;
  FormExperience: string;
  // Submission Error
  // submission error message
  submissionError: string;
}

export const defaultForm = (): iNominationFormValues => {
  const defaultValues: iNominationFormValues = {
    OBLIGATION_NUMBER: '',
    isOfficerIssued: null,
    InfringementNumber: '',
    InfringementNoticeNumber: '',
    alreadySavedForm: false,
    // Step 2
    OFFENCE_DATE: null,
    HEARING_DATE: null,
    DRIVER_LICENCE: '',
    VEHICLE_REGISTRATION: '',
    DOB: null,
    // Step 3
    WasHandedInPerson: '',
    OFFENCE_FIND_OUT_DATE: null,
    DebtorId: 0,
    // Step 3 save
    SaveYesNo: '',
    SaveOptions: '',
    saveEmail: '',
    saveMobile: '',
    IsSubscribedEM: false,
    IsSubscribedSMS: false,
    EMRemeinderSent: false,
    SMSRemeinderSent: false,
    // Step 4
    isThePersonNamed: '',
    Status: '',
    DebtorType: '',
    isDebtorTypeIndividual: false,
    // Step 5
    SelectedGroundInfo: '',
    FineStage: '',
    HasBeenNominatedBefore: false,
    OffenceType: '',
    IsMarineOffence: false,
    IsTsvOffence: false,
    IsSeriousOffence: false,
    selectTheOption: '',
    closeTheOption: '',
    // Step 6 someone else
    WhoAreYouNominating: '',
    // person details
    GivenNamesSomeoneElse: '',
    FamilyNameSomeoneElse: '',
    DOBSomeoneElse: null,
    DOBYesNoSomeoneElse: false,
    DriverLicenseSomeoneElse: '',
    LicenceStateSomeoneElse: '',
    StatecountryOfIssueSomeoneElse: 'Australia',
    NoDriverLicenseSomeoneElse: false,
    TaxDriverAccNumber: '',
    ResidentialAddressSomeoneElse: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    NoResidentialAddressSomeoneElse: '',
    NoEmailSomeoneElse: '',
    EmailSomeoneElse: '',
    IndividualContactNumberSomeoneElse: {
      ContactNumber: '',
    },
    NoContactNumberSomeoneElse: '',
    EmailSomeoneElseWarning: '',
    IndividualContactNumberSomeoneElseWarning: '',
    // company details
    CompanyNameSomeoneElse: '',
    AbnacnTypeSomeoneElse: '',
    AcnNoSomeoneElse: '',
    isACNValidSomeoneElse: false,
    NoOrgContactNumberSomeoneElse: false,
    AbnNoSomeoneElse: '',
    isABNValidSomeoneElse: false,
    CompanyStreetAddressSomeoneElse: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    OrganisationContactNumberSomeoneElse: {
      ContactNumber: '',
    },
    CompanyEmailSomeOneElse: '',
    CompanyEmailYesNoSomeOneElse: false,
    CompanyEmailSomeOneElseWarning: '',
    OrganisationContactNumberSomeoneElseWarning: '',
    // step 7
    TransferedVicRoads: '',
    DateSellOrDispose: null,
    FileUploadSizeConfig: 0,
    FileUploadDescriptionConfig: '',
    FileUploadMaxAttachmentsConfig: 0,
    EvidenceSoldOrDispose: [],
    EvidenceSoldOrDisposeNameField: '',
    EvidenceSoldOrDisposeProvider: '',
    EvidenceSoldOrDisposeFilesDescription: '',
    EvidenceSoldOrDisposeErrorHandle: false,
    EvidenceSoldOrDisposeSizeErrorHandle: false,
    EvidenceSoldOrDisposeFileUploadErrorHandle: false,
    EvidenceSoldOrDisposeFileSectionError: '',
    WhoAreYouNominatingSoldDispose: '',
    // step 7 person
    GivenNamesSoldDisposed: '',
    FamilyNameSoldDisposed: '',
    DOBSoldDisposed: null,
    DOBYesNoSoldDisposed: false,
    DriverLicenseSoldDisposed: '',
    LicenceStateSoldDisposed: '',
    StatecountryOfIssueSoldDisposed: 'Australia',
    NoDriverLicenseSoldDisposed: false,
    ResidentialAddressSoldDisposed: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    NoEmailSoldDisposed: '',
    EmailSoldDisposed: '',
    IndividualContactNumberSoldDisposed: {
      ContactNumber: '',
    },
    EmailSoldDisposedWarning: '',
    IndividualContactNumberSoldDisposedWarning: '',
    NoContactNumberSoldDisposed: '',
    // step 7 Company
    CompanyNameSoldDisposed: '',
    AbnacnTypeSoldDisposed: '',
    AcnNoSoldDisposed: '',
    isACNValidSoldDisposed: false,
    OrganisationContactNumberYesNoSoldDisposed: '',
    AbnNoSoldDisposed: '',
    isABNValidSoldDisposed: false,
    CompanyStreetAddressSoldDisposed: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    OrganisationContactNumberSoldDisposed: {
      ContactNumber: '',
    },
    NoOrgContactNumberSoldDisposed: false,
    CompanyEmailSoldDisposed: '',
    CompanyEmailYesNoSoldDisposed: '',
    CompanyEmailSoldDisposedWarning: '',
    OrganisationContactNumberSoldDisposedWarning: '',
    // Step 8
    VictoriaPoliceReferenceNumber: '',

    VehicleOrIdentificationStolenOrFalse: [],
    VehicleOrIdentificationStolenOrFalseNameField: '',
    VehicleOrIdentificationStolenOrFalseProvider: '',
    VehicleOrIdentificationStolenOrFalseDescription: '',
    VehicleOrIdentificationStolenOrFalseErrorHandle: false,
    VehicleOrIdentificationStolenOrFalseSizeErrorHandle: false,
    VehicleOrIdentificationStolenOrFalseFileUploadErrorHandle: false,
    VehicleOrIdentificationStolenOrFalseFileSectionError: '',

    // Step 9
    IncorrectNominationExplanation: '',

    RejectionSupportingDocs: [],
    RejectionSupportingDocsNameField: '',
    RejectionSupportingDocsProvider: '',
    RejectionSupportingDocsDescription: '',
    RejectionSupportingDocsErrorHandle: false,
    RejectionSupportingDocsSizeErrorHandle: false,
    RejectionSupportingDocsFileUploadErrorHandle: false,
    RejectionSupportingDocsFileSectionError: '',

    // Step 10
    UnableToIdentifyExplanation: '',

    UnableToIdentify: [],
    UnableToIdentifyNameField: '',
    UnableToIdentifyProvider: '',
    UnableToIdentifyDescription: '',
    UnableToIdentifyErrorHandle: false,
    UnableToIdentifySizeErrorHandle: false,
    UnableToIdentifyFileUploadErrorHandle: false,
    UnableToIdentifyFileSectionError: '',

    // Step 11
    // person
    GivenNamesYourDetails: '',
    FamilyNameYourDetails: '',
    DOBYourDetails: null,
    DriverLicenseYourDetails: '',
    LicenceStateYourDetails: '',
    StatecountryOfIssueYourDetails: 'Australia',
    NoDriverLicenseYourDetails: '',
    IndividualPostalAddressYourDetails: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    DifferentToPostalYourDetails: '',
    ResidentialAddressYourDetails: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    NoEmailYourDetails: '',
    EmailYourDetails: '',
    IndividualContactNumberYourDetails: {
      ContactNumber: '',
    },
    NoContactNumberYourDetails: '',
    EmailYourDetailsWarning: '',
    IndividualContactNumberYourDetailsWarning: '',
    // company
    GivenNamesYourDetailsCompany: '',
    FamilyNameYourDetailsCompany: '',
    PositionInCompanyYourDetailsCompany: '',
    OrganisationContactNumberYourDetailsCompany: {
      ContactNumber: '',
    },
    NoOrgContactNumberYourDetails: '',
    CompanyEmailYourDetails: '',
    CompanyEmailYesNoYourDetails: '',
    CompanyNameYourDetailsCompany: '',
    AbnacnTypeYourDetails: '',
    AcnNoYourDetails: '',
    isACNValidYourDetails: false,
    OrganisationContactNumberYesNoYourDetails: '',
    AbnNoYourDetails: '',
    isABNValidYourDetails: false,
    CompanyStreetAddressYourDetails: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    DifferentToStreetAddressYourDetails: '',
    CompanyPostalAddressYourDetails: {
      SearchText: '',
      Address: '',
      LineOne: '',
      LineTwo: '',
      Suburb: '',
      State: '',
      Postcode: '',
      Country: 'Australia',
    },
    CompanyEmailYourDetailsWarning: '',
    OrganisationContactNumberYourDetailsCompanyWarning: '',

    // Step 12
    CheckAndConfirmPageLoaded: false,
    // Step 14
    nominationConsentToDeclaration: false,

    // Submission
    submissionNo: '',
    FormExperience: '',
    // Submission Error
    submissionError: '',

    // Partial Forms
    ID: '',
    PartialFormID: '',
    Obligations: [],
    FormData: {
      a: '',
      // is submitted
      submitted: false,
      OBLIGATION_NUMBER: '',
      InfringementNoticeNumber: '',
      // Step 2
      OFFENCE_DATE: null,
      HEARING_DATE: null,
      VEHICLE_REGISTRATION: '',
      DRIVER_LICENCE: '',
      DOB: null,

      // Step 4
      isThePersonNamed: '',
      Status: '',
      DebtorType: '',
      isDebtorTypeIndividual: false,
      // Step 3
      SaveYesNo: '',
      SaveOptions: '',
      saveEmail: '',
      saveMobile: '',

      // Step 5
      SelectedGroundInfo: '',
      FineStage: '',
      HasBeenNominatedBefore: false,
      OffenceType: '',
      IsMarineOffence: false,
      IsTsvOffence: false,
      IsSeriousOffence: false,
      selectTheOption: '',
      closeTheOption: '',
      // Step 6 someone else
      WhoAreYouNominating: '',
      // person details
      GivenNamesSomeoneElse: '',
      FamilyNameSomeoneElse: '',
      DOBSomeoneElse: null,
      DOBYesNoSomeoneElse: false,
      DriverLicenseSomeoneElse: '',
      LicenceStateSomeoneElse: '',
      StatecountryOfIssueSomeoneElse: '',
      NoDriverLicenseSomeoneElse: false,
      TaxDriverAccNumber: '',
      ResidentialAddressSomeoneElse: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      NoResidentialAddressSomeoneElse: '',
      NoEmailSomeoneElse: '',
      EmailSomeoneElse: '',
      IndividualContactNumberSomeoneElse: {
        ContactNumber: '',
      },
      NoContactNumberSomeoneElse: '',
      EmailSomeoneElseWarning: '',
      IndividualContactNumberSomeoneElseWarning: '',
      // company details
      CompanyNameSomeoneElse: '',
      AbnacnTypeSomeoneElse: '',
      AcnNoSomeoneElse: '',
      isACNValidSomeoneElse: false,
      NoOrgContactNumberSomeoneElse: false,
      AbnNoSomeoneElse: '',
      isABNValidSomeoneElse: false,
      CompanyStreetAddressSomeoneElse: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      OrganisationContactNumberSomeoneElse: {
        ContactNumber: '',
      },
      CompanyEmailSomeOneElse: '',
      CompanyEmailYesNoSomeOneElse: false,
      CompanyEmailSomeOneElseWarning: '',
      OrganisationContactNumberSomeoneElseWarning: '',
      // step 7
      TransferedVicRoads: '',
      DateSellOrDispose: null,
      WhoAreYouNominatingSoldDispose: '',
      EvidenceSoldOrDispose: [],
      EvidenceSoldOrDisposeNameField: '',
      EvidenceSoldOrDisposeProvider: '',
      EvidenceSoldOrDisposeFilesDescription: '',
      EvidenceSoldOrDisposeErrorHandle: false,
      EvidenceSoldOrDisposeSizeErrorHandle: false,
      EvidenceSoldOrDisposeFileUploadErrorHandle: false,
      EvidenceSoldOrDisposeFileSectionError: '',
      // step 7 person
      GivenNamesSoldDisposed: '',
      FamilyNameSoldDisposed: '',
      DOBSoldDisposed: null,
      DOBYesNoSoldDisposed: false,
      DriverLicenseSoldDisposed: '',
      LicenceStateSoldDisposed: '',
      StatecountryOfIssueSoldDisposed: '',
      NoDriverLicenseSoldDisposed: false,
      ResidentialAddressSoldDisposed: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      NoEmailSoldDisposed: '',
      EmailSoldDisposed: '',
      IndividualContactNumberSoldDisposed: {
        ContactNumber: '',
      },
      EmailSoldDisposedWarning: '',
      IndividualContactNumberSoldDisposedWarning: '',
      NoContactNumberSoldDisposed: '',
      // step 7 Company
      CompanyNameSoldDisposed: '',
      AbnacnTypeSoldDisposed: '',
      AcnNoSoldDisposed: '',
      isACNValidSoldDisposed: false,
      OrganisationContactNumberYesNoSoldDisposed: '',
      AbnNoSoldDisposed: '',
      isABNValidSoldDisposed: false,
      CompanyStreetAddressSoldDisposed: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      OrganisationContactNumberSoldDisposed: {
        ContactNumber: '',
      },
      NoOrgContactNumberSoldDisposed: false,
      CompanyEmailSoldDisposed: '',
      CompanyEmailYesNoSoldDisposed: '',
      CompanyEmailSoldDisposedWarning: '',
      OrganisationContactNumberSoldDisposedWarning: '',

      // Step 8
      VictoriaPoliceReferenceNumber: '',

      VehicleOrIdentificationStolenOrFalse: [],
      VehicleOrIdentificationStolenOrFalseNameField: '',
      VehicleOrIdentificationStolenOrFalseProvider: '',
      VehicleOrIdentificationStolenOrFalseDescription: '',
      VehicleOrIdentificationStolenOrFalseErrorHandle: false,
      VehicleOrIdentificationStolenOrFalseSizeErrorHandle: false,
      VehicleOrIdentificationStolenOrFalseFileUploadErrorHandle: false,
      VehicleOrIdentificationStolenOrFalseFileSectionError: '',

      // Step 9
      IncorrectNominationExplanation: '',
      RejectionSupportingDocs: [],
      RejectionSupportingDocsNameField: '',
      RejectionSupportingDocsProvider: '',
      RejectionSupportingDocsDescription: '',
      RejectionSupportingDocsErrorHandle: false,
      RejectionSupportingDocsSizeErrorHandle: false,
      RejectionSupportingDocsFileUploadErrorHandle: false,
      RejectionSupportingDocsFileSectionError: '',

      // Step 10
      UnableToIdentifyExplanation: '',

      UnableToIdentify: [],
      UnableToIdentifyNameField: '',
      UnableToIdentifyProvider: '',
      UnableToIdentifyDescription: '',
      UnableToIdentifyErrorHandle: false,
      UnableToIdentifySizeErrorHandle: false,
      UnableToIdentifyFileUploadErrorHandle: false,
      UnableToIdentifyFileSectionError: '',
      // Step 11
      // person
      GivenNamesYourDetails: '',
      FamilyNameYourDetails: '',
      DOBYourDetails: null,
      DriverLicenseYourDetails: '',
      LicenceStateYourDetails: '',
      StatecountryOfIssueYourDetails: 'Australia',
      NoDriverLicenseYourDetails: '',
      IndividualPostalAddressYourDetails: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      DifferentToPostalYourDetails: '',
      ResidentialAddressYourDetails: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      NoEmailYourDetails: '',
      EmailYourDetails: '',
      IndividualContactNumberYourDetails: {
        ContactNumber: '',
      },
      NoContactNumberYourDetails: '',
      EmailYourDetailsWarning: '',
      IndividualContactNumberYourDetailsWarning: '',
      // company
      GivenNamesYourDetailsCompany: '',
      FamilyNameYourDetailsCompany: '',
      PositionInCompanyYourDetailsCompany: '',
      OrganisationContactNumberYourDetailsCompany: {
        ContactNumber: '',
      },
      NoOrgContactNumberYourDetails: '',
      CompanyEmailYourDetails: '',
      CompanyEmailYesNoYourDetails: '',
      CompanyNameYourDetailsCompany: '',
      AbnacnTypeYourDetails: '',
      AcnNoYourDetails: '',
      isACNValidYourDetails: false,
      OrganisationContactNumberYesNoYourDetails: '',
      AbnNoYourDetails: '',
      isABNValidYourDetails: false,
      CompanyStreetAddressYourDetails: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      DifferentToStreetAddressYourDetails: '',
      CompanyPostalAddressYourDetails: {
        SearchText: '',
        Address: '',
        LineOne: '',
        LineTwo: '',
        Suburb: '',
        State: '',
        Postcode: '',
        Country: 'Australia',
      },
      CompanyEmailYourDetailsWarning: '',
      OrganisationContactNumberYourDetailsCompanyWarning: '',
      // Step 12
      CheckAndConfirmPageLoaded: false,
      // Step 14
      nominationConsentToDeclaration: false,
    }
  };
  return defaultValues;
};

export const NominationSchema = Yup.object().shape({
  saveEmail: Yup.string().matches(EMAIL_SPECIAL_CHARS_REGEX, INVALID_EMAIL).email(INVALID_EMAIL).required(INVALID_NUMERIC_FORMAT),
  saveMobile: Yup.string()
    .min(10, INVALID_MOBILE_NUMBER_FORMAT)
    .max(10, INVALID_PHONE_NUMBER_LENGTH)
    .matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER)
    .required(INVALID_PHONE_NUMBER),
  SaveYesNo: Yup.string().required(INVALID_YESNO_FORMAT),
  SaveOptions: Yup.string().when('SaveYesNo', {
    is: 'true',
    then: Yup.string().required(INVALID_NUMERIC_FORMAT),
  }),
  OBLIGATION_NUMBER: Yup.string().matches(OBLIGATION_REGEX, INVALID_OBLIGATION_NUMBER).required(INVALID_NUMERIC_FORMAT),
  OFFENCE_DATE: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE),
  HEARING_DATE: Yup.date().required(EMPTY_DATE).nullable(),
  DRIVER_LICENCE: Yup.string()
    .required(INVALID_NUMERIC_FORMAT)
    .matches(/^[a-zA-Z0-9 ]*$/, INVALID_LICENCE_FORMAT_NOMINATION)
    .max(25, INVALID_INPUT_LONGER_THAN_25_CHARS),
  VEHICLE_REGISTRATION: Yup.string().matches(VEHICLE_REGISTRATION_REGEX, INVALID_VEHICLE_REGISTRATION_NUMBER).max(12, INVALID_VEHICLE_REGISTRATION_NUMBER_LENGTH).required(INVALID_VEHICLE_REGISTRATION_NUMBER),
  DOB: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE),
  OFFENCE_FIND_OUT_DATE: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE)
    .min(new Date(today.setDate(today.getDate() - 15)), INVALID_OFFENCE_FIND_OUT_DATE),
  WasHandedInPerson: Yup.string().required(INVALID_YESNO_FORMAT),

  DetailsForCircumstances: Yup.string().matches(FREE_TEXT_FIELD_REGEX, INVALID_FREE_TEXT_FIELD_FORMAT).required(INVALID_NUMERIC_FORMAT),
  // step 4 validation
  isThePersonNamed: Yup.string().required(INVALID_NUMERIC_FORMAT).test('isThePersonNamed', '', (value) => value !== 'false'),
  // step 5 validation
  selectTheOption: Yup.string().required(INVALID_NUMERIC_FORMAT),
  // step 6 validations
  WhoAreYouNominating: Yup.string().required(INVALID_YESNO_FORMAT),
  GivenNamesSomeoneElse: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  FamilyNameSomeoneElse: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  TaxDriverAccNumber: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS),
  DriverLicenseSomeoneElse: Yup.string()
    .required(INVALID_NUMERIC_FORMAT)
    .matches(/^[a-zA-Z0-9 ]*$/, INVALID_LICENCE_FORMAT_NOMINATION)
    .max(25, INVALID_INPUT_LONGER_THAN_25_CHARS),
  StatecountryOfIssueSomeoneElse: Yup.string(),
  LicenceStateSomeoneElse: Yup.string().required(INVALID_NUMERIC_FORMAT),
  NoDriverLicenseSomeoneElse: Yup.boolean(),
  DOBSomeoneElse: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE),
  ResidentialAddressSomeoneElse: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE_NOMINATION).max(10, INVALID_INPUT_LONGER_THAN_10_CHARS).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().when('Country', {
      is: 'Australia',
      then: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
      otherwise: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
    }),
  }),
  IndividualContactNumberSomeoneElse: Yup.object().shape({
    ContactNumber: Yup.string().max(15, INVALID_PHONE_NUMBER_LENGTH_15).matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER).required(INVALID_PHONE_NUMBER),
  }),
  EmailSomeoneElse: Yup.string()
    .matches(EMAIL_SPECIAL_CHARS_REGEX, INVALID_EMAIL)
    .email(INVALID_EMAIL)
    .max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION)
    .required(INVALID_NUMERIC_FORMAT),
  // step 6 company details
  CompanyNameSomeoneElse: Yup.string().matches(COMPANY_NAME_REGEX, INVALID_COMPANY_NAME).max(75, INVALID_INPUT_LONGER_THAN_75_CHARS).required(INVALID_NUMERIC_FORMAT),
  AbnacnTypeSomeoneElse: Yup.string().required(INVALID_YESNO_FORMAT),
  AcnNoSomeoneElse: Yup.string().required(INVALID_NUMERIC_FORMAT)
  .min(ACN_MIN_LENGTH, INVALID_ACN)
  .test('is-valid', INVALID_ACN, function (value) {
    const { isACNValidSomeoneElse } = this.parent;
    return isACNValidSomeoneElse;
  }),
  AbnNoSomeoneElse: Yup.string().required(INVALID_NUMERIC_FORMAT)
  .min(ABN_MIN_LENGTH, INVALID_ABN)
  .test('is-valid', INVALID_ABN, function (value) {
    const { isABNValidSomeoneElse } = this.parent;
    return isABNValidSomeoneElse;
  }),

  CompanyStreetAddressSomeoneElse: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE_NOMINATION).max(10, INVALID_INPUT_LONGER_THAN_10_CHARS).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().when('Country', {
      is: 'Australia',
      then: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
      otherwise: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
    }),
  }),
  OrganisationContactNumberSomeoneElse: Yup.object().shape({
    ContactNumber: Yup.string().max(15, INVALID_PHONE_NUMBER_LENGTH_15).matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER).required(INVALID_PHONE_NUMBER),
  }),
  CompanyEmailSomeOneElse: Yup.string()
    .matches(EMAIL_SPECIAL_CHARS_REGEX, INVALID_EMAIL)
    .email(INVALID_EMAIL)
    .max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION)
    .required(INVALID_NUMERIC_FORMAT),
  // END step 6
  // step 7
  TransferedVicRoads: Yup.string().required(INVALID_YESNO_FORMAT),
  DateSellOrDispose: Yup.date()
    .required(EMPTY_DATE)
    .nullable()
    .when('OFFENCE_DATE', (OFFENCE_DATE, schema) => schema.when('IsMarineOffence', (IsMarineOffence: boolean, schemaInner: any) => schemaInner.test({
      test: (DateSellOrDispose: Date) => !DateSellOrDispose || DateSellOrDispose <= new Date(OFFENCE_DATE),
      message: `The date indicates you were still in possession of the ${IsMarineOffence ? 'vessel' : 'vehicle'} at the time of the offence.`,
    }))),
  WhoAreYouNominatingSoldDispose: Yup.string().required(INVALID_YESNO_FORMAT),
  EvidenceSoldOrDisposeSizeErrorHandle: Yup.boolean()
    .oneOf([false])
    .when('FileUploadSizeConfig', (FileUploadSizeConfig, schema) => (
      FileUploadSizeConfig
        ? schema.oneOf([false], `Sorry, this file is either too large (must be less than ${FileUploadSizeConfig}MB) or it’s a file type we don’t accept. Accepted file types include: doc, docx, xls, xlsx, csv, jpeg, png, pdf, txt.'`)
        : schema
    )),
  EvidenceSoldOrDisposeFileUploadErrorHandle: Yup.boolean().oneOf([false], FILE_UPLOAD_FAIL),
  EvidenceSoldOrDisposeFileSectionError: Yup.boolean().when('EvidenceSoldOrDispose', {
    is: (EvidenceSoldOrDispose: []) => EvidenceSoldOrDispose.length < 1,
    then: Yup.boolean().required('Please attach a document'),
  }),
  // step 7 person
  GivenNamesSoldDisposed: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  FamilyNameSoldDisposed: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  DriverLicenseSoldDisposed: Yup.string()
    .required(INVALID_NUMERIC_FORMAT)
    .matches(/^[a-zA-Z0-9 ]*$/, INVALID_LICENCE_FORMAT_NOMINATION)
    .max(25, INVALID_INPUT_LONGER_THAN_25_CHARS),
  StatecountryOfIssueSoldDisposed: Yup.string(),
  LicenceStateSoldDisposed: Yup.string().required(INVALID_NUMERIC_FORMAT),
  NoDriverLicenseSoldDisposed: Yup.boolean(),
  DOBSoldDisposed: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE),
  ResidentialAddressSoldDisposed: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE_NOMINATION).max(10, INVALID_INPUT_LONGER_THAN_10_CHARS).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().when('Country', {
      is: 'Australia',
      then: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
      otherwise: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
    }),
  }),
  IndividualContactNumberSoldDisposed: Yup.object().shape({
    ContactNumber: Yup.string().max(15, INVALID_PHONE_NUMBER_LENGTH_15).matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER).required(INVALID_PHONE_NUMBER),
  }),
  EmailSoldDisposed: Yup.string()
    .matches(EMAIL_SPECIAL_CHARS_REGEX, INVALID_EMAIL)
    .email(INVALID_EMAIL)
    .max(100, INVALID_EMAIL)
    .required(INVALID_NUMERIC_FORMAT),
  // step 7 company
  CompanyNameSoldDisposed: Yup.string().matches(COMPANY_NAME_REGEX, INVALID_COMPANY_NAME).max(75, INVALID_INPUT_LONGER_THAN_75_CHARS).required(INVALID_NUMERIC_FORMAT),
  AbnacnTypeSoldDisposed: Yup.string().required(INVALID_YESNO_FORMAT),
  AcnNoSoldDisposed: Yup.string().required(INVALID_NUMERIC_FORMAT)
  .min(ACN_MIN_LENGTH, INVALID_ACN)
  .test('is-valid', INVALID_ACN, function (value) {
    const { isACNValidSoldDisposed } = this.parent;
    return isACNValidSoldDisposed;
  }),
  AbnNoSoldDisposed: Yup.string().required(INVALID_NUMERIC_FORMAT)
  .min(ABN_MIN_LENGTH, INVALID_ABN)
  .test('is-valid', INVALID_ABN, function (value) {
    const { isABNValidSoldDisposed } = this.parent;
    return isABNValidSoldDisposed;
  }),
  OrganisationContactNumberSoldDisposed: Yup.object().shape({
    ContactNumber: Yup.string().max(15, INVALID_PHONE_NUMBER_LENGTH_15).matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER).required(INVALID_PHONE_NUMBER),
  }),
  CompanyStreetAddressSoldDisposed: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE_NOMINATION).max(10, INVALID_INPUT_LONGER_THAN_10_CHARS).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().when('Country', {
      is: 'Australia',
      then: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
      otherwise: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
    }),
  }),
  CompanyEmailSoldDisposed: Yup.string()
    .matches(EMAIL_SPECIAL_CHARS_REGEX, INVALID_EMAIL)
    .email(INVALID_EMAIL)
    .max(100, INVALID_EMAIL)
    .required(INVALID_NUMERIC_FORMAT),
  // Step 8
  VictoriaPoliceReferenceNumber: Yup.string()
  .when('VehicleOrIdentificationStolenOrFalse', {
    is: (VehicleOrIdentificationStolenOrFalse: []) => VehicleOrIdentificationStolenOrFalse.length < 1,
    then: Yup.string().required('Please complete one or more fields to continue').trim(INVALID_NUMBER_INPUT).ensure()
      .min(1, 'Please complete one or more fields to continue')
      .max(80, INVALID_INPUT_LONGER_THAN_80_CHARS)
  }),
  VehicleOrIdentificationStolenOrFalseSizeErrorHandle: Yup.boolean()
    .oneOf([false])
    .when('FileUploadSizeConfig', (FileUploadSizeConfig, schema) => (
      FileUploadSizeConfig
        ? schema.oneOf([false], `Sorry, this file is either too large (must be less than ${FileUploadSizeConfig}MB) or it’s a file type we don’t accept. Accepted file types include: doc, docx, xls, xlsx, csv, jpeg, png, pdf, txt.'`)
        : schema
    )),
  VehicleOrIdentificationStolenOrFalseFileUploadErrorHandle: Yup.boolean().oneOf([false], FILE_UPLOAD_FAIL),
  VehicleOrIdentificationStolenOrFalseFileSectionError: Yup.boolean().when('VehicleOrIdentificationStolenOrFalse', {
    is: (VehicleOrIdentificationStolenOrFalse: []) => VehicleOrIdentificationStolenOrFalse.length < 1,
    then: Yup.boolean().when('VictoriaPoliceReferenceNumber', {
      is: '',
      then: Yup.boolean().required('Please complete one or more fields on this page to continue')
    }),
  }),
  // Step 9
  IncorrectNominationExplanation: Yup.string().matches(FREE_TEXT_FIELD_REGEX, INVALID_FREE_TEXT_FIELD_FORMAT).required(INVALID_NUMERIC_FORMAT),
  RejectionSupportingDocsSizeErrorHandle: Yup.boolean()
    .oneOf([false])
    .when('FileUploadSizeConfig', (FileUploadSizeConfig, schema) => (
      FileUploadSizeConfig
        ? schema.oneOf([false], `Sorry, this file is either too large (must be less than ${FileUploadSizeConfig}MB) or it’s a file type we don’t accept. Accepted file types include: doc, docx, xls, xlsx, csv, jpeg, png, pdf, txt.'`)
        : schema
    )),
  RejectionSupportingDocsFileUploadErrorHandle: Yup.boolean().oneOf([false], FILE_UPLOAD_FAIL),
  // Step 10
  UnableToIdentifyExplanation: Yup.string().matches(FREE_TEXT_FIELD_REGEX, INVALID_FREE_TEXT_FIELD_FORMAT).required(INVALID_NUMERIC_FORMAT),
  UnableToIdentifySizeErrorHandle: Yup.boolean()
    .oneOf([false])
    .when('FileUploadSizeConfig', (FileUploadSizeConfig, schema) => (
      FileUploadSizeConfig
        ? schema.oneOf([false], `Sorry, this file is either too large (must be less than ${FileUploadSizeConfig}MB) or it’s a file type we don’t accept. Accepted file types include: doc, docx, xls, xlsx, csv, jpeg, png, pdf, txt.'`)
        : schema
    )),
  UnableToIdentifyFileUploadErrorHandle: Yup.boolean().oneOf([false], FILE_UPLOAD_FAIL),
  // Step 11
  // step 7 person
  GivenNamesYourDetails: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  FamilyNameYourDetails: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  DOBYourDetails: Yup.date().required(EMPTY_DATE).nullable().max(new Date(), INVALID_FUTURE_DATE),
  DriverLicenseYourDetails: Yup.string()
    .required(INVALID_NUMERIC_FORMAT)
    .matches(/^[a-zA-Z0-9 ]*$/, INVALID_LICENCE_FORMAT_NOMINATION)
    .max(25, INVALID_INPUT_LONGER_THAN_25_CHARS),
  StatecountryOfIssueYourDetails: Yup.string(),
  LicenceStateYourDetails: Yup.string().required(INVALID_NUMERIC_FORMAT),
  NoDriverLicenseYourDetails: Yup.boolean(),
  IndividualPostalAddressYourDetails: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE_NOMINATION).max(10, INVALID_INPUT_LONGER_THAN_10_CHARS).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().when('Country', {
      is: 'Australia',
      then: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
      otherwise: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
    }),
  }),
  DifferentToPostalYourDetails: Yup.string().required(INVALID_YESNO_FORMAT),
  ResidentialAddressYourDetails: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE_NOMINATION).max(10, INVALID_INPUT_LONGER_THAN_10_CHARS).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().when('Country', {
      is: 'Australia',
      then: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
      otherwise: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
    }),
  }),
  IndividualContactNumberYourDetails: Yup.object().shape({
    ContactNumber: Yup.string().max(15, INVALID_PHONE_NUMBER_LENGTH_15).matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER).required(INVALID_PHONE_NUMBER),
  }),
  EmailYourDetails: Yup.string()
    .matches(EMAIL_SPECIAL_CHARS_REGEX, INVALID_EMAIL)
    .email(INVALID_EMAIL)
    .max(100, INVALID_EMAIL)
    .required(INVALID_NUMERIC_FORMAT),
  // step 7 company
  GivenNamesYourDetailsCompany: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  FamilyNameYourDetailsCompany: Yup.string().matches(NAMES_FIELDS_REGEX, INVALID_NAME_FORMAT_NEW).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  PositionInCompanyYourDetailsCompany: Yup.string().matches(POSITION_IN_COMPANY_REGEX, INVALID_POSITION_IN_COMPANY_FIELD).max(80, INVALID_INPUT_LONGER_THAN_80_CHARS).required(INVALID_NUMERIC_FORMAT),
  CompanyEmailYourDetails: Yup.string()
    .matches(EMAIL_SPECIAL_CHARS_REGEX, INVALID_EMAIL)
    .email(INVALID_EMAIL)
    .max(100, INVALID_EMAIL)
    .required(INVALID_NUMERIC_FORMAT),
  CompanyNameYourDetailsCompany: Yup.string().matches(COMPANY_NAME_REGEX, INVALID_COMPANY_NAME).max(75, INVALID_INPUT_LONGER_THAN_75_CHARS).required(INVALID_NUMERIC_FORMAT),
  AbnacnTypeYourDetails: Yup.string().required(INVALID_YESNO_FORMAT),
  AcnNoYourDetails: Yup.string().required(INVALID_NUMERIC_FORMAT)
  .min(ACN_MIN_LENGTH, INVALID_ACN)
  .test('is-valid', INVALID_ACN, function (value) {
    const { isACNValidYourDetails } = this.parent;
    return isACNValidYourDetails;
  }),
  AbnNoYourDetails: Yup.string().required(INVALID_NUMERIC_FORMAT)
  .min(ABN_MIN_LENGTH, INVALID_ABN)
  .test('is-valid', INVALID_ABN, function (value) {
    const { isABNValidYourDetails } = this.parent;
    return isABNValidYourDetails;
  }),
  OrganisationContactNumberYourDetailsCompany: Yup.object().shape({
    ContactNumber: Yup.string().max(15, INVALID_PHONE_NUMBER_LENGTH_15).matches(CONTACT_NUMBER_REGEX, INVALID_PHONE_NUMBER).required(INVALID_PHONE_NUMBER),
  }),
  CompanyStreetAddressYourDetails: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE_NOMINATION).max(10, INVALID_INPUT_LONGER_THAN_10_CHARS).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().when('Country', {
      is: 'Australia',
      then: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
      otherwise: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
    }),
  }),
  DifferentToStreetAddressYourDetails: Yup.string().required(INVALID_YESNO_FORMAT),
  CompanyPostalAddressYourDetails: Yup.object().shape({
    SearchText: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    LineOne: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS).required(INVALID_NUMERIC_FORMAT),
    LineTwo: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(200, INVALID_INPUT_LONGER_THAN_200_CHARS),
    Suburb: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    Postcode: Yup.string().matches(POST_CODE_REGEX, INVALID_POST_CODE_NOMINATION).max(10, INVALID_INPUT_LONGER_THAN_10_CHARS).required(INVALID_NUMERIC_FORMAT),
    Country: Yup.string().max(50, INVALID_INPUT_LONGER_THAN_50_CHARS).required(INVALID_NUMERIC_FORMAT),
    State: Yup.string().when('Country', {
      is: 'Australia',
      then: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
      otherwise: Yup.string().matches(ADDRESS_FIELD_CHARS_REGEX, INVALID_ADDRESS_FIELD_ERROR).max(100, INVALID_INPUT_LONGER_THAN_100_CHARS_NOMINATION).required(INVALID_NUMERIC_FORMAT),
    }),
  }),
  // Step 14
  nominationConsentToDeclaration: Yup.boolean().oneOf([true], MISSING_DECLARATION_AGREEMENT)
});

export const NominationMetaData: iFormMetaData = {
  pagesSegments: {
    step0: {
      progressStep: ProgressStep.START,
      validationKeys: () => [],
    },
    step1: {
      progressStep: ProgressStep.START,
      validationKeys: (values: FormikValues) => keys(values, NOMINATION).page1,
    },
    step2: {
      progressStep: ProgressStep.START,
      validationKeys: (values: FormikValues) => keys(values, NOMINATION).page2,
    },
    step3: {
      progressStep: ProgressStep.START,
      validationKeys: (values: FormikValues) => keys(values, NOMINATION).page3,
    },
    step4: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, NOMINATION).page4,
    },
    step5: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, NOMINATION).page5,
    },
    step6: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, NOMINATION).page6,
    },
    step7: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, NOMINATION).page7,
    },
    step8: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, NOMINATION).page8,
    },
    step9: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, NOMINATION).page9,
    },
    step10: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, NOMINATION).page10,
    },
    step11: {
      progressStep: ProgressStep.DETAILS,
      validationKeys: (values: FormikValues) => keys(values, NOMINATION).page11
    },
    step12: {
      progressStep: ProgressStep.CHECK_CONFIRM,
      validationKeys: (values: FormikValues) => keys(values, NOMINATION).page12,
    },
    step13: {
      progressStep: ProgressStep.CHECK_CONFIRM,
      validationKeys: (values: FormikValues) => keys(values, NOMINATION).page13,
    },
    step14: {
      progressStep: ProgressStep.DONE,
      validationKeys: (values: FormikValues) => keys(values, NOMINATION).page14,
    }
  },
};
const displayFileDetails = (attachment: iAttachments) => {
  if (attachment.FileName !== '' && attachment.FileDescription !== '') {
    return `${attachment.FileName} : ${attachment.FileDescription}`;
  }
  if (attachment.FileName !== '' && attachment.FileDescription === '') {
    return `${attachment.FileName}`;
  }
  return '';
};
const joinAddressFields = (entry: string[]) => {
  if (entry[0] === 'Address' || entry[0] === 'SearchText') return null;
  if (entry[0] === 'Country') return entry[1];
  return entry[1];
};
export const getSummaryScreen = (values: iNominationFormValues): iSummary[] => {
  // const checkOptSupportingDoc = values.SupportingDocuments.map((attachment) => displayFileDetails(attachment))
  //   .filter(Boolean)
  //   .join('\n');
  const tSVBoatingMaringOffenceStr = values.IsMarineOffence || values.IsTsvOffence ? 'vessel' : 'vehicle';
  let displayThePage = '0';
  const selectedOption = values.selectTheOption;
  switch (true) {
    case selectedOption === 'SelectedGroundInfo0':
      displayThePage = '6';
      break;
    case selectedOption === 'SelectedGroundInfo1':
      displayThePage = '7';
      break;
    case selectedOption === 'SelectedGroundInfo2':
      displayThePage = '8';
      break;
    case selectedOption === 'SelectedGroundInfo3':
      displayThePage = '9';
      break;
    case selectedOption === 'SelectedGroundInfo4':
      displayThePage = '10';
      break;
    default:
      displayThePage = '0';
      break;
  }
  const page4 = {
    title: 'Are you the person named on the fine?',
    editLink: '/step4',
    fields: [
      [{
        title: 'Are you the person named on the fine?',
        value: values.isThePersonNamed === 'true' ? 'Yes' : 'No',
      }],
    ]
  };
  const page5 = {
    title: 'Which nomination statement applies?',
    editLink: '/step5',
    fields: [[
      {
        title: 'Which nomination statement applies?',
        value: values.SelectedGroundInfo,
      },
    ],
    ]
  };
  const page6 = {
    title: `Someone else was the person in possession of the ${tSVBoatingMaringOffenceStr} at the time of the offence`,
    editLink: '/step6',
    fields: values.WhoAreYouNominating === 'Company' ? [
      [{ title: 'Are you nominating a person or a company?', value: values.WhoAreYouNominating === 'Company' ? 'Company' : 'Person' }],
      [{ title: 'Company name', value: values.CompanyNameSomeoneElse }],
      [{ title: 'ACN or ABN (an ACN is preferred)', value: values.AbnacnTypeSomeoneElse }],
      [{ title: 'Enter the ACN/ABN number', value: values.AbnacnTypeSomeoneElse === 'ACN' ? values.AcnNoSomeoneElse : values.AbnNoSomeoneElse }],
      [
        {
          title: 'Street address',
          value: `${Object.entries(values.CompanyStreetAddressSomeoneElse)
            .map((entry) => joinAddressFields(entry))
            .filter(Boolean)
            .join(', ')}`,
        },
      ],
      [{ title: 'Contact phone number', value: values.NoOrgContactNumberSomeoneElse === false ? values.OrganisationContactNumberSomeoneElse.ContactNumber : 'n/a' }],
      [{ title: 'Email address', value: values.CompanyEmailYesNoSomeOneElse === false ? values.CompanyEmailSomeOneElse : 'n/a' }],
    ] : [
      [{ title: 'Are you nominating a person or a company?', value: values.WhoAreYouNominating === 'true' ? 'Company' : 'Person' }],
      [{ title: 'Given name(s)', value: values.GivenNamesSomeoneElse }],
      [{ title: 'Family name', value: values.FamilyNameSomeoneElse }],
      [{ title: 'Date of birth', value: values.DOBSomeoneElse ? `${(`0${values.DOBSomeoneElse.getDate()}`).slice(-2)}/${(`0${values.DOBSomeoneElse.getMonth() + 1}`).slice(-2)}/${values.DOBSomeoneElse.getFullYear()}` : 'n/a' }],
      [{ title: 'Taxi driver accreditation number', value: values.TaxDriverAccNumber ? values.TaxDriverAccNumber : 'n/a' }],
      [
        values.NoDriverLicence
          ? { title: 'Licence number', value: 'n/a' }
          : { title: 'Licence number', value: values.DriverLicenseSomeoneElse ? values.DriverLicenseSomeoneElse : 'n/a' },
      ],
      [
        values.NoDriverLicenseSomeoneElse
          ? { title: 'Place of issue', value: 'n/a' }
          : {
            title: 'Place of issue',
            value:
              // eslint-disable-next-line no-nested-ternary
              values.StatecountryOfIssueSomeoneElse === 'Australia' ? (values.LicenceStateSomeoneElse ? values.LicenceStateSomeoneElse : 'n/a') : values.StatecountryOfIssueSomeoneElse ? values.StatecountryOfIssueSomeoneElse : 'n/a',
          },
      ],
      [
        {
          title: 'Residential address',
          value: `${Object.entries(values.ResidentialAddressSomeoneElse)
            .map((entry) => joinAddressFields(entry))
            .filter(Boolean)
            .join(', ')}`,
        },
      ],
      [{ title: 'Contact number', value: values.NoContactNumberSomeoneElse.toString() !== 'true' ? values.IndividualContactNumberSomeoneElse.ContactNumber : 'n/a' }],
      [{ title: 'Email address', value: values.NoEmailSomeoneElse ? 'n/a' : values.EmailSomeoneElse }],
    ]
  };
  const page7 = {
    title: `The ${tSVBoatingMaringOffenceStr} was sold or permanently disposed of before the offence`,
    editLink: '/step7',
    fields: [
      [{ title: `Has the ${tSVBoatingMaringOffenceStr} been transferred with VicRoads?`, value: values.TransferedVicRoads === 'true' ? 'Yes' : 'No' }],
      [{ title: `What date did you sell or dispose of the ${tSVBoatingMaringOffenceStr}?`, value: values.DateSellOrDispose instanceof Date ? `${(`0${values.DateSellOrDispose.getDate()}`).slice(-2)}/${(`0${values.DateSellOrDispose.getMonth() + 1}`).slice(-2)}/${values.DateSellOrDispose?.getFullYear()}` : 'n/a' }],
      [
        {
          title: 'Supporting documents',
          value: values.EvidenceSoldOrDispose && values.EvidenceSoldOrDispose.length > 0 ? values.EvidenceSoldOrDispose.map((attachment) => displayFileDetails(attachment))
            .filter(Boolean)
            .join('\n')
            : 'n/a',
        },
      ],
      ...(values.WhoAreYouNominatingSoldDispose === 'Company' ? [
        [{ title: 'Who are you nominating?', value: values.WhoAreYouNominatingSoldDispose === 'Company' ? 'Company' : 'Person' }],
        [{ title: 'Company name', value: values.CompanyNameSoldDisposed }],
        [{ title: 'ACN or ABN (an ACN is preferred)', value: values.AbnacnTypeSoldDisposed }],
        [{ title: 'Enter the ACN/ABN number', value: values.AbnacnTypeSoldDisposed === 'ACN' ? values.AcnNoSoldDisposed : values.AbnNoSoldDisposed }],
        [
          {
            title: 'Street address',
            value: `${Object.entries(values.CompanyStreetAddressSoldDisposed)
              .map((entry) => joinAddressFields(entry))
              .filter(Boolean)
              .join(', ')}`,
          },
        ],
        [{ title: 'Contact phone number', value: values.NoOrgContactNumberSoldDisposed === false ? values.OrganisationContactNumberSoldDisposed.ContactNumber : 'n/a' }],
        [{ title: 'Email address', value: values.CompanyEmailSoldDisposed ? values.CompanyEmailSoldDisposed : 'n/a' }],
      ] : [
        [{ title: 'Given name(s)', value: values.GivenNamesSoldDisposed }],
        [{ title: 'Family name', value: values.FamilyNameSoldDisposed }],
        [{ title: 'Date of birth', value: values.DOBSoldDisposed instanceof Date ? `${(`0${values.DOBSoldDisposed.getDate()}`).slice(-2)}/${(`0${values.DOBSoldDisposed.getMonth() + 1}`).slice(-2)}/${values.DOBSoldDisposed.getFullYear()}` : 'n/a' }],
        [
          values.NoDriverLicenseSoldDisposed
            ? { title: 'Licence number', value: 'n/a' }
            : { title: 'Licence number', value: values.DriverLicenseSoldDisposed ? values.DriverLicenseSoldDisposed : 'n/a' },
        ],
        [
          values.NoDriverLicenseSoldDisposed
            ? { title: 'Place of issue', value: 'n/a' }
            : {
              title: 'Place of issue',
              value:
                // eslint-disable-next-line no-nested-ternary
                values.StatecountryOfIssueSoldDisposed === 'Australia' ? (values.LicenceStateSoldDisposed ? values.LicenceStateSoldDisposed : 'n/a') : values.StatecountryOfIssueSoldDisposed ? values.StatecountryOfIssueSoldDisposed : 'n/a',
            },
        ],
        [
          {
            title: 'Residential address',
            value: `${Object.entries(values.ResidentialAddressSoldDisposed)
              .map((entry) => joinAddressFields(entry))
              .filter(Boolean)
              .join(', ')}`,
          },
        ],
        [{ title: 'Contact number', value: values.NoContactNumberSoldDisposed.toString() !== 'true' ? values.IndividualContactNumberSoldDisposed.ContactNumber : 'n/a' }],
        [{ title: 'Email address', value: values.EmailSoldDisposed ? values.EmailSoldDisposed : 'n/a' }],
      ])
    ]
  };
  const page8 = {
    title: `The ${tSVBoatingMaringOffenceStr} or number plates were stolen or copied/cloned`,
    editLink: '/step8',
    fields: [[
      {
        title: 'Victoria Police reference number',
        value: values.VictoriaPoliceReferenceNumber && values.VictoriaPoliceReferenceNumber.length > 0 ? values.VictoriaPoliceReferenceNumber : 'n/a',
      },
    ],
    [
      {
        title: 'Supporting documents',
        value: values.VehicleOrIdentificationStolenOrFalse && values.VehicleOrIdentificationStolenOrFalse.length > 0 ? values.VehicleOrIdentificationStolenOrFalse.map((attachment) => displayFileDetails(attachment))
          .filter(Boolean)
          .join('\n')
          : 'n/a',
      },
    ],
    ]
  };
  const page9 = {
    title: 'Why are you rejecting the nomination?',
    editLink: '/step9',
    fields: [[
      {
        title: 'Explain why you believe your nomination is incorrect',
        value: values.IncorrectNominationExplanation,
      },
    ],
    [
      {
        title: 'Supporting documents',
        value: values.RejectionSupportingDocs && values.RejectionSupportingDocs.length > 0 ? values.RejectionSupportingDocs.map((attachment) => displayFileDetails(attachment))
          .filter(Boolean)
          .join('\n')
          : 'n/a',
      },
    ],
    ]
  };
  const page10 = {
    title: `You cannot identify who was in possession of the ${tSVBoatingMaringOffenceStr} at the time of the offence`,
    editLink: '/step10',
    fields: [[
      {
        title: 'Please tell us how you have tried to identify the person responsible for the offence',
        value: values.UnableToIdentifyExplanation,
      },
    ],
    [
      {
        title: 'Supporting documents',
        value: values.UnableToIdentify && values.UnableToIdentify.length > 0 ? values.UnableToIdentify.map((attachment) => displayFileDetails(attachment))
          .filter(Boolean)
          .join('\n')
          : 'n/a',
      },
    ],
    ]
  };
  const page11 = {
    title: 'Your details',
    editLink: '/step11',
    fields: !values.isDebtorTypeIndividual ? [
      [{ title: 'Given name(s)', value: values.GivenNamesYourDetailsCompany }],
      [{ title: 'Family name', value: values.FamilyNameYourDetailsCompany }],
      [{ title: 'Position in company', value: values.PositionInCompanyYourDetailsCompany }],
      [{ title: 'Contact phone number', value: values.NoOrgContactNumberYourDetails !== 'true' ? values.OrganisationContactNumberYourDetailsCompany.ContactNumber : 'n/a' }],
      values.CompanyEmailYesNoYourDetails !== 'true' ? [{ title: 'Email address', value: values.CompanyEmailYourDetails ? values.CompanyEmailYourDetails : 'n/a' }] : [],
      [{ title: 'Company name', value: values.CompanyNameYourDetailsCompany }],
      [{ title: 'ACN or ABN (an ACN is preferred)', value: values.AbnacnTypeYourDetails }],
      [{ title: 'Enter the ACN/ABN number', value: values.AbnacnTypeYourDetails === 'ACN' ? values.AcnNoYourDetails : values.AbnNoYourDetails }],
      [
        {
          title: "Company's street address",
          value: `${Object.entries(values.CompanyStreetAddressYourDetails)
            .map((entry) => joinAddressFields(entry))
            .filter(Boolean)
            .join(', ')}`,
        },
      ],
      values.DifferentToStreetAddressYourDetails === 'true' ? [
        {
          title: "Company's postal address",
          value: `${Object.entries(values.CompanyPostalAddressYourDetails)
            .map((entry) => joinAddressFields(entry))
            .filter(Boolean)
            .join(', ')}`,
        },
      ] : [],
    ] : [
      [{ title: 'Given name(s)', value: values.GivenNamesYourDetails }],
      [{ title: 'Family name', value: values.FamilyNameYourDetails }],
      [{ title: 'Date of birth', value: values.DOBYourDetails ? `${(`0${values.DOBYourDetails.getDate()}`).slice(-2)}/${(`0${values.DOBYourDetails.getMonth() + 1}`).slice(-2)}/${values.DOBYourDetails.getFullYear()}` : 'n/a' }],
      [
        values.NoDriverLicenseYourDetails
          ? { title: 'Licence number', value: 'n/a' }
          : { title: 'Licence number', value: values.DRIVER_LICENCE ? values.DRIVER_LICENCE : 'n/a' },
      ],
      [
        values.NoDriverLicenseYourDetails
          ? { title: 'Place of issue', value: 'n/a' }
          : {
            title: 'Place of issue',
            value:
              // eslint-disable-next-line no-nested-ternary
              values.StatecountryOfIssueYourDetails === 'Australia' ? (values.LicenceStateYourDetails ? values.LicenceStateYourDetails : 'n/a') : values.StatecountryOfIssueYourDetails ? values.StatecountryOfIssueYourDetails : 'n/a',
          },
      ],
      [
        {
          title: 'Postal address',
          value: `${Object.entries(values.IndividualPostalAddressYourDetails)
            .map((entry) => joinAddressFields(entry))
            .filter(Boolean)
            .join(', ')}`,
        },
      ],
      values.DifferentToPostalYourDetails === 'true' ? [
        {
          title: 'Residential address',
          value: `${Object.entries(values.ResidentialAddressYourDetails)
            .map((entry) => joinAddressFields(entry))
            .filter(Boolean)
            .join(', ')}`,
        },
      ] : [],
      [{ title: 'Contact number', value: values.NoContactNumberYourDetails !== 'true' ? values.IndividualContactNumberYourDetails.ContactNumber : 'n/a' }],
      values.NoEmailYourDetails !== 'true' ? [{ title: 'Email address', value: values.EmailYourDetails ? values.EmailYourDetails : 'n/a' }] : [],
    ]
  };
  const pagesExtensionSummary: iSummary[] = [
    values.isDebtorTypeIndividual ? page4 : ({} as iSummary),
    page5,
    displayThePage === '6' ? page6 : ({} as iSummary),
    displayThePage === '7' ? page7 : ({} as iSummary),
    displayThePage === '8' ? page8 : ({} as iSummary),
    displayThePage === '9' ? page9 : ({} as iSummary),
    displayThePage === '10' ? page10 : ({} as iSummary),
    page11,
  ];
  const summarySections: iSummary[] = pagesExtensionSummary;
  return summarySections;
};

export interface iSubmitNominationFormValues extends iCommonNominationValues {
  // OBLIGATION FIELDS
  YourObligationNumber: string;
  InfringementNoticeNumber: string;
  OffenceDate: string;
  WhichStatementBestDescribesYou: string;
  // Footer Pg 1
  FooterSubmissionNo1: string;
  FooterFormType1: string;
  FooterObligationNo1: string;
  FooterSubmittedTime1: string;
  // Footer Pg 2
  FooterSubmissionNo2: string;
  FooterFormType2: string;
  FooterObligationNo2: string;
  FooterSubmittedTime2: string;
  // Footer Pg 3
  FooterSubmissionNo3: string;
  FooterFormType3: string;
  FooterObligationNo3: string;
  FooterSubmittedTime3: string;

  // YOUR DETAILS
  YourGivenNames: string;
  YourFamilyName: string;
    // Contact Details
  YourContactNumber: string;
  YourEmailAddress: string;

  // Individual
  YourDateOfBirth: string;
  YourDriverLicenceNumber: string;
  YourPlaceOfIssue: string;
  YourStateOfIssue: string;
    // Postal address
  YourPostalLineOne: string;
  YourPostalLineTwo: string;
  YourPostalSuburb: string;
  YourPostalState: string;
  YourPostalPostcode: string;
  YourPostalCountry: string;
  // Residential Address
  YourResidentialLineOne: string;
  YourResidentialLineTwo: string;
  YourResidentialSuburb: string;
  YourResidentialState: string;
  YourResidentialPostcode: string;
  YourResidentialCountry: string;

  // Company
  YourPositionInCompany: string;

  // COMPANY DETAILS
  CompanyName: string;
  CompanyACNABN: string;
  CompanyACNABNNumber: string;
   // Street address
  CompanyStreetLineOne: string;
  CompanyStreetLineTwo: string;
  CompanyStreetSuburb: string;
  CompanyStreetState: string;
  CompanyStreetPostcode: string;
  CompanyStreetCountry: string;
  // Postal address
  CompanyPostalLineOne: string;
  CompanyPostalLineTwo: string;
  CompanyPostalSuburb: string;
  CompanyPostalState: string;
  CompanyPostalPostcode: string;
  CompanyPostalCountry: string;

  // GROUNDS FOR NOMINATION
  GroundsForNomination: string;
  VehicleTransferVicRoads: string;
  DateVehicleSoldDisposedOf: string;

  // PERSON OR COMPANY YOU ARE NOMINATING, WHO WAS IN POSSESSION OR CONTROL OF THE VEHICLE AT THE TIME OF THE OFFENCE
  NominatedGivenNames: string;
  NominatedFamilyName: string;
  NominatedDateOfBirth: string;
  NominatedTaxiDriverAccreditationNumber: string;
  NominatedDriverLicenceNumber: string;
  NominatedPlaceOfIssue: string;
  NominatedStateOfIssue: string;
    // Residential Address
  NominatedResidentialLineOne: string;
  NominatedResidentialLineTwo: string;
  NominatedResidentialSuburb: string;
  NominatedResidentialState: string;
  NominatedResidentialPostcode: string;
  NominatedResidentialCountry: string;
  // Contact Details
  NominatedContactNumber: string;
  NominatedEmailAddress: string;
    // Company Details
  NominatedCompanyName: string;
  NominatedACNABN: string;
  NominatedACNABNNumber: string;
  NominatedPositionInCompany: string;
    // Company Street Address
  NominatedCompanyStreetLineOne: string;
  NominatedCompanyStreetLineTwo: string;
  NominatedCompanySuburb: string;
  NominatedCompanyState: string;
  NominatedCompanyPostcode: string;
  NominatedCompanyCountry: string;
    // Contact Details
  NominatedCompanyContactNumber: string;
  NominatedCompanyEmailAddress: string;

  // WHY ARE YOU REJECTING THE NOMINATION/WHAT STEPS DID YOU TAKE TO IDENTIFY THE DRIVER?
  WhatStepsDidYouTake: string;

  // SUPPORTING MATERIAL
  NumberOfAttachments: number;
  PoliceReportReferenceNumber: string;

  // DECLARATION
  YourSignature: string;
  DeclarationDate: string;

  // Other - Backend Required
  ATTACHMENTS: string;
  OBLIGATION_NUMBER: string;
  EMAIL_TO: string;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getReceiptPayload = (formValues: any): string => `{
  "ID": "",
  "Receipt": "",
  "Obligations": [
      {
          "ID": "",
          "ObligationNO": "${formValues.OBLIGATION_NUMBER}",
          "IsPrimary": "true",
          "ReceptNumberId": ""
      }
  ],
  "SubmittedDate": "",
  "FormTypeId": 3
}`;

export const getSubmissionPayload = (formValues: iNominationFormValues, submissionNumber: string, nominationEndpoint: string): iSubmitNominationFormValues => {
  const submitFormValues = formValues;
  const now = new Date();
  const MONTH = (`0${now.getMonth() + 1}`).slice(-2);
  const DATE = (`0${now.getDate()}`).slice(-2);
  const YEAR = now.getFullYear();
  const MINUTE = (now.getMinutes() < 10 ? '0' : '') + now.getMinutes();
  const SUBMITTED_TIME = `${now.getHours()}:${MINUTE} ${DATE}/${MONTH}/${YEAR}`;
  const FORM_TYPE = 'Nomination';
  const totalNumberOfAttachments = formValues.EvidenceSoldOrDispose?.length + formValues.VehicleOrIdentificationStolenOrFalse?.length + formValues.RejectionSupportingDocs?.length + formValues.UnableToIdentify?.length;
  let remoteAttachmentNames = '';
  const descriptionOfAttachmentsArray = [
    ...(formValues.EvidenceSoldOrDispose || []),
    ...(formValues.VehicleOrIdentificationStolenOrFalse || []),
    ...(formValues.RejectionSupportingDocs || []),
    ...(formValues.UnableToIdentify || []),
  ];
  if (descriptionOfAttachmentsArray) {
    descriptionOfAttachmentsArray.forEach((v) => {
      if (v.RemoteFileName) {
        remoteAttachmentNames += `${formValues.OBLIGATION_NUMBER}/${v.RemoteFileName}/${v.RemoteFileName}|`;
      }
    });
  }
  let groundsInfo = '';
  if (formValues.SelectedGroundInfo.includes('Someone else')) {
    groundsInfo = 'someoneElse';
  } else if (formValues.SelectedGroundInfo.includes('sold or permanently disposed')) {
    groundsInfo = 'sold/disposed';
  } else if (formValues.SelectedGroundInfo.includes('stolen or cloned/copied')) {
    groundsInfo = 'stolen/copied';
  } else if (formValues.SelectedGroundInfo.includes('wrongly nominated')) {
    groundsInfo = 'wrong';
  } else if (formValues.SelectedGroundInfo.includes('cannot identify ')) {
    groundsInfo = 'cantIdentify';
  }
  const submitObject: iSubmitNominationFormValues = {
    ...(submitFormValues as iCommonNominationValues),
    // OBLIGATION FIELDS
    YourObligationNumber: formValues.OBLIGATION_NUMBER ? formValues.OBLIGATION_NUMBER : '',
    InfringementNoticeNumber: formValues.InfringementNoticeNumber ? formValues.InfringementNoticeNumber : '',
    OffenceDate: formValues.OFFENCE_DATE ? `${(`0${formValues.OFFENCE_DATE.getDate()}`).slice(-2)}/${(`0${formValues.OFFENCE_DATE.getMonth() + 1}`).slice(-2)}/${formValues.OFFENCE_DATE.getFullYear()}` : '',
    WhichStatementBestDescribesYou: formValues.isDebtorTypeIndividual ? 'I am the person named on the fine' : 'I am an authorised company representative',
    // Footer Pg 1
    FooterSubmissionNo1: submissionNumber,
    FooterFormType1: FORM_TYPE,
    FooterObligationNo1: formValues.OBLIGATION_NUMBER,
    FooterSubmittedTime1: SUBMITTED_TIME,
    // Footer Pg 2
    FooterSubmissionNo2: submissionNumber,
    FooterFormType2: FORM_TYPE,
    FooterObligationNo2: formValues.OBLIGATION_NUMBER,
    FooterSubmittedTime2: SUBMITTED_TIME,
    // Footer Pg 3
    FooterSubmissionNo3: submissionNumber,
    FooterFormType3: FORM_TYPE,
    FooterObligationNo3: formValues.OBLIGATION_NUMBER,
    FooterSubmittedTime3: SUBMITTED_TIME,

    // YOUR DETAILS
    YourGivenNames: formValues.isDebtorTypeIndividual ? formValues.GivenNamesYourDetails : formValues.GivenNamesYourDetailsCompany,
    YourFamilyName: formValues.isDebtorTypeIndividual ? formValues.FamilyNameYourDetails : formValues.FamilyNameYourDetailsCompany,
      // Contact Details
    YourContactNumber: formValues.isDebtorTypeIndividual ? formValues.IndividualContactNumberYourDetails.ContactNumber : formValues.OrganisationContactNumberYourDetailsCompany.ContactNumber,
    YourEmailAddress: formValues.isDebtorTypeIndividual ? ((formValues.NoEmailYourDetails !== 'true') ? formValues.EmailYourDetails : '') : (formValues.CompanyEmailYesNoYourDetails !== 'true' ? formValues.CompanyEmailYourDetails : ''),
    // Individual
    YourDateOfBirth: formValues.DOBYourDetails ? `${(`0${formValues.DOBYourDetails.getDate()}`).slice(-2)}/${(`0${formValues.DOBYourDetails.getMonth() + 1}`).slice(-2)}/${formValues.DOBYourDetails.getFullYear()}` : '',
    YourDriverLicenceNumber: !formValues.NoDriverLicenseYourDetails ? formValues.DRIVER_LICENCE : '',
    YourPlaceOfIssue: !formValues.NoDriverLicenseYourDetails ? formValues.StatecountryOfIssueYourDetails : '',
    YourStateOfIssue: !formValues.NoDriverLicenseYourDetails ? (formValues.StatecountryOfIssueYourDetails === 'Australia') ? formValues.LicenceStateYourDetails : 'International' : '',
      // Postal address
    YourPostalLineOne: formValues.IndividualPostalAddressYourDetails.LineOne ? formValues.IndividualPostalAddressYourDetails.LineOne : '',
    YourPostalLineTwo: formValues.IndividualPostalAddressYourDetails.LineTwo ? formValues.IndividualPostalAddressYourDetails.LineTwo : '',
    YourPostalSuburb: formValues.IndividualPostalAddressYourDetails.Suburb ? formValues.IndividualPostalAddressYourDetails.Suburb : '',
    YourPostalState: formValues.IndividualPostalAddressYourDetails.State ? formValues.IndividualPostalAddressYourDetails.State : '',
    YourPostalPostcode: formValues.IndividualPostalAddressYourDetails.Postcode ? formValues.IndividualPostalAddressYourDetails.Postcode : '',
    YourPostalCountry: formValues.IndividualPostalAddressYourDetails.Country ? formValues.IndividualPostalAddressYourDetails.Country : '',
    // Residential Address Individual
    YourResidentialLineOne: (formValues.DifferentToPostalYourDetails === 'true') ? formValues.ResidentialAddressYourDetails.LineOne : formValues.IndividualPostalAddressYourDetails.LineOne,
    YourResidentialLineTwo: (formValues.DifferentToPostalYourDetails === 'true') ? formValues.ResidentialAddressYourDetails.LineTwo : formValues.IndividualPostalAddressYourDetails.LineTwo,
    YourResidentialSuburb: (formValues.DifferentToPostalYourDetails === 'true') ? formValues.ResidentialAddressYourDetails.Suburb : formValues.IndividualPostalAddressYourDetails.Suburb,
    YourResidentialState: (formValues.DifferentToPostalYourDetails === 'true') ? formValues.ResidentialAddressYourDetails.State : formValues.IndividualPostalAddressYourDetails.State,
    YourResidentialPostcode: (formValues.DifferentToPostalYourDetails === 'true') ? formValues.ResidentialAddressYourDetails.Postcode : formValues.IndividualPostalAddressYourDetails.Postcode,
    YourResidentialCountry: (formValues.DifferentToPostalYourDetails === 'true') ? formValues.ResidentialAddressYourDetails.Country : formValues.IndividualPostalAddressYourDetails.Country,

    // Company
    YourPositionInCompany: formValues.PositionInCompanyYourDetailsCompany ? formValues.PositionInCompanyYourDetailsCompany : '',

    // COMPANY DETAILS
    CompanyName: formValues.CompanyNameYourDetailsCompany ? formValues.CompanyNameYourDetailsCompany : '',
    CompanyACNABN: formValues.AbnacnTypeYourDetails ? formValues.AbnacnTypeYourDetails : '',
    CompanyACNABNNumber: (formValues.AbnacnTypeYourDetails === 'ACN') ? (formValues.AcnNoYourDetails ? formValues.AcnNoYourDetails : '') : (formValues.AbnNoYourDetails ? formValues.AbnNoYourDetails : ''),
     // Street address
    CompanyStreetLineOne: formValues.CompanyStreetAddressYourDetails.LineOne ? formValues.CompanyStreetAddressYourDetails.LineOne : '',
    CompanyStreetLineTwo: formValues.CompanyStreetAddressYourDetails.LineTwo ? formValues.CompanyStreetAddressYourDetails.LineTwo : '',
    CompanyStreetSuburb: formValues.CompanyStreetAddressYourDetails.Suburb ? formValues.CompanyStreetAddressYourDetails.Suburb : '',
    CompanyStreetState: formValues.CompanyStreetAddressYourDetails.State ? formValues.CompanyStreetAddressYourDetails.State : '',
    CompanyStreetPostcode: formValues.CompanyStreetAddressYourDetails.Postcode ? formValues.CompanyStreetAddressYourDetails.Postcode : '',
    CompanyStreetCountry: formValues.CompanyStreetAddressYourDetails.Country ? formValues.CompanyStreetAddressYourDetails.Country : '',
    // Postal address
    CompanyPostalLineOne: (formValues.DifferentToStreetAddressYourDetails === 'true') ? formValues.CompanyPostalAddressYourDetails.LineOne : formValues.CompanyStreetAddressYourDetails.LineOne,
    CompanyPostalLineTwo: (formValues.DifferentToStreetAddressYourDetails === 'true') ? formValues.CompanyPostalAddressYourDetails.LineTwo : formValues.CompanyStreetAddressYourDetails.LineTwo,
    CompanyPostalSuburb: (formValues.DifferentToStreetAddressYourDetails === 'true') ? formValues.CompanyPostalAddressYourDetails.Suburb : formValues.CompanyStreetAddressYourDetails.Suburb,
    CompanyPostalState: (formValues.DifferentToStreetAddressYourDetails === 'true') ? formValues.CompanyPostalAddressYourDetails.State : formValues.CompanyStreetAddressYourDetails.State,
    CompanyPostalPostcode: (formValues.DifferentToStreetAddressYourDetails === 'true') ? formValues.CompanyPostalAddressYourDetails.Postcode : formValues.CompanyStreetAddressYourDetails.Postcode,
    CompanyPostalCountry: (formValues.DifferentToStreetAddressYourDetails === 'true') ? formValues.CompanyPostalAddressYourDetails.Country : formValues.CompanyStreetAddressYourDetails.Country,

    // GROUNDS FOR NOMINATION
    GroundsForNomination: formValues.SelectedGroundInfo ? formValues.SelectedGroundInfo : '',
    VehicleTransferVicRoads: (formValues.TransferedVicRoads !== '') ? ((formValues.TransferedVicRoads === 'true') ? 'Yes' : 'No') : '',
    DateVehicleSoldDisposedOf: formValues.DateSellOrDispose ? `${(`0${formValues.DateSellOrDispose.getDate()}`).slice(-2)}/${(`0${formValues.DateSellOrDispose.getMonth() + 1}`).slice(-2)}/${formValues.DateSellOrDispose.getFullYear()}` : '',

    // PERSON OR COMPANY YOU ARE NOMINATING, WHO WAS IN POSSESSION OR CONTROL OF THE VEHICLE AT THE TIME OF THE OFFENCE
    NominatedGivenNames: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Person') ? formValues.GivenNamesSomeoneElse : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Person') ? formValues.GivenNamesSoldDisposed : ''),
    NominatedFamilyName: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Person') ? formValues.FamilyNameSomeoneElse : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Person') ? formValues.FamilyNameSoldDisposed : ''),
    NominatedDateOfBirth: (groundsInfo === 'someoneElse') ? (!formValues.DOBYesNoSomeoneElse ? ((formValues.WhoAreYouNominating === 'Person' && formValues.DOBSomeoneElse) ? `${(`0${formValues.DOBSomeoneElse.getDate()}`).slice(-2)}/${(`0${formValues.DOBSomeoneElse.getMonth() + 1}`).slice(-2)}/${formValues.DOBSomeoneElse.getFullYear()}` : '') : '') : (!formValues.DOBYesNoSoldDisposed ? ((formValues.WhoAreYouNominatingSoldDispose === 'Person' && formValues.DOBSoldDisposed) ? `${(`0${formValues.DOBSoldDisposed.getDate()}`).slice(-2)}/${(`0${formValues.DOBSoldDisposed.getMonth() + 1}`).slice(-2)}/${formValues.DOBSoldDisposed.getFullYear()}` : '') : ''),
    NominatedTaxiDriverAccreditationNumber: (formValues.WhoAreYouNominating === 'Person') ? formValues.TaxDriverAccNumber : '',
    NominatedDriverLicenceNumber: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Person') ? formValues.DriverLicenseSomeoneElse : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Person') ? formValues.DriverLicenseSoldDisposed : ''),
    NominatedPlaceOfIssue: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Person') ? formValues.StatecountryOfIssueSomeoneElse : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Person') ? formValues.StatecountryOfIssueSoldDisposed : ''),
    NominatedStateOfIssue: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Person') ? (formValues.StatecountryOfIssueSomeoneElse === 'Australia' ? formValues.LicenceStateSomeoneElse : 'International') : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Person') ? (formValues.StatecountryOfIssueSoldDisposed === 'Australia' ? formValues.LicenceStateSoldDisposed : 'International') : ''),
     // Residential Address
    NominatedResidentialLineOne: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Person') ? formValues.ResidentialAddressSomeoneElse.LineOne : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Person') ? formValues.ResidentialAddressSoldDisposed.LineOne : ''),
    NominatedResidentialLineTwo: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Person') ? formValues.ResidentialAddressSomeoneElse.LineTwo : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Person') ? formValues.ResidentialAddressSoldDisposed.LineTwo : ''),
    NominatedResidentialSuburb: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Person') ? formValues.ResidentialAddressSomeoneElse.Suburb : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Person') ? formValues.ResidentialAddressSoldDisposed.Suburb : ''),
    NominatedResidentialState: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Person') ? formValues.ResidentialAddressSomeoneElse.State : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Person') ? formValues.ResidentialAddressSoldDisposed.State : ''),
    NominatedResidentialPostcode: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Person') ? formValues.ResidentialAddressSomeoneElse.Postcode : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Person') ? formValues.ResidentialAddressSoldDisposed.Postcode : ''),
    NominatedResidentialCountry: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Person') ? formValues.ResidentialAddressSomeoneElse.Country : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Person') ? formValues.ResidentialAddressSoldDisposed.Country : ''),
    // Contact Details
    NominatedContactNumber: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Person') ? formValues.IndividualContactNumberSomeoneElse.ContactNumber : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Person') ? formValues.IndividualContactNumberSoldDisposed.ContactNumber : formValues.OrganisationContactNumberSoldDisposed.ContactNumber),
    NominatedEmailAddress: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Person') ? formValues.EmailSomeoneElse : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Person') ? formValues.EmailSoldDisposed : formValues.CompanyEmailSoldDisposed),
      // Company Details
    NominatedCompanyName: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Company') ? formValues.CompanyNameSomeoneElse : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Company') ? formValues.CompanyNameSoldDisposed : ''),
    NominatedACNABN: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Company') ? formValues.AbnacnTypeSomeoneElse : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Company') ? formValues.AbnacnTypeSoldDisposed : ''),
    NominatedACNABNNumber: (groundsInfo === 'someoneElse') ? ((formValues.AbnacnTypeSomeoneElse === 'ACN') ? ((formValues.WhoAreYouNominating === 'Company') ? formValues.AcnNoSomeoneElse : '') : ((formValues.WhoAreYouNominating === 'Company') ? formValues.AbnNoSomeoneElse : '')) : ((formValues.AbnacnTypeSoldDisposed === 'ACN') ? ((formValues.WhoAreYouNominatingSoldDispose === 'Company') ? formValues.AcnNoSoldDisposed : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Company') ? formValues.AbnNoSoldDisposed : '')),
    NominatedPositionInCompany: '',
      // Company Street Address
    NominatedCompanyStreetLineOne: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Company') ? formValues.CompanyStreetAddressSomeoneElse.LineOne : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Company') ? formValues.CompanyStreetAddressSoldDisposed.LineOne : ''),
    NominatedCompanyStreetLineTwo: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Company') ? formValues.CompanyStreetAddressSomeoneElse.LineTwo : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Company') ? formValues.CompanyStreetAddressSoldDisposed.LineTwo : ''),
    NominatedCompanySuburb: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Company') ? formValues.CompanyStreetAddressSomeoneElse.Suburb : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Company') ? formValues.CompanyStreetAddressSoldDisposed.Suburb : ''),
    NominatedCompanyState: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Company') ? formValues.CompanyStreetAddressSomeoneElse.State : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Company') ? formValues.CompanyStreetAddressSoldDisposed.State : ''),
    NominatedCompanyPostcode: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Company') ? formValues.CompanyStreetAddressSomeoneElse.Postcode : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Company') ? formValues.CompanyStreetAddressSoldDisposed.Postcode : ''),
    NominatedCompanyCountry: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Company') ? formValues.CompanyStreetAddressSomeoneElse.Country : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Company') ? formValues.CompanyStreetAddressSoldDisposed.Country : ''),
      // Contact Details
    NominatedCompanyContactNumber: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Company') ? formValues.OrganisationContactNumberSomeoneElse.ContactNumber : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Company') ? formValues.OrganisationContactNumberSoldDisposed.ContactNumber : ''),
    NominatedCompanyEmailAddress: (groundsInfo === 'someoneElse') ? ((formValues.WhoAreYouNominating === 'Company') ? formValues.CompanyEmailSomeOneElse : '') : ((formValues.WhoAreYouNominatingSoldDispose === 'Company') ? formValues.CompanyEmailSoldDisposed : ''),

    // WHY ARE YOU REJECTING THE NOMINATION/WHAT STEPS DID YOU TAKE TO IDENTIFY THE DRIVER?
    WhatStepsDidYouTake: (groundsInfo === 'cantIdentify') ? formValues.UnableToIdentifyExplanation : formValues.IncorrectNominationExplanation,

    // SUPPORTING MATERIAL
    NumberOfAttachments: totalNumberOfAttachments,
    PoliceReportReferenceNumber: formValues.VictoriaPoliceReferenceNumber,

    // DECLARATION
    YourSignature: formValues.nominationConsentToDeclaration ? 'I agree with the statements' : '',
    DeclarationDate: `${DATE}/${MONTH}/${YEAR}`,

    // Other - Backend Required
    ATTACHMENTS: remoteAttachmentNames,
    OBLIGATION_NUMBER: formValues.OBLIGATION_NUMBER ? formValues.OBLIGATION_NUMBER : '',
    EMAIL_TO: (formValues.isDebtorTypeIndividual) ? (formValues.EmailYourDetails ? formValues.EmailYourDetails : '') : (formValues.CompanyEmailYourDetails ? formValues.CompanyEmailYourDetails : ''),
  };

  const excludeKeysFromForm: string[] = [
    'a',
    'AbnNoSoldDisposed',
    'AbnNoSomeoneElse',
    'AbnNoYourDetails',
    'AbnacnTypeSoldDisposed',
    'AbnacnTypeSomeoneElse',
    'AbnacnTypeYourDetails',
    'AcnNoSoldDisposed',
    'AcnNoSomeoneElse',
    'AbnacnTypeSomeoneElse',
    'AcnNoYourDetails',
    'Attachments',
    'CheckAndConfirmPageLoaded',
    'CompanyEmailSoldDisposed',
    'CompanyEmailSomeOneElse',
    'CompanyEmailYesNoSoldDisposed',
    'CompanyEmailYesNoSomeOneElse',
    'CompanyEmailYesNoYourDetails',
    'CompanyEmailYourDetails',
    'CompanyNameSoldDisposed',
    'CompanyNameSomeoneElse',
    'CompanyNameYourDetailsCompany',
    'CompanyPostalAddressYourDetails',
    'CompanyStreetAddressSoldDisposed',
    'CompanyStreetAddressSomeoneElse',
    'CompanyStreetAddressYourDetails',
    'CreateDate',
    'DOB',
    'DOBRequired',
    'DOBSoldDisposed',
    'DOBSomeoneElse',
    'DOBYesNoSoldDisposed',
    'DOBYesNoSomeoneElse',
    'DOBYourDetails',
    'DRIVER_LICENCE',
    'DateSellOrDispose',
    'DebtorId',
    'DebtorID',
    'DebtorType',
    'DifferentToPostalYourDetails',
    'DifferentToStreetAddressYourDetails',
    'differentToStreetAddressYourDetails',
    'DriverLicenseSoldDisposed',
    'DriverLicenseSomeoneElse',
    'DriverLicenseYourDetails',
    'EMRemeinderSent',
    'Email',
    'EmailSoldDisposed',
    'EmailSomeoneElse',
    'EmailYourDetails',
    'EvidenceSoldOrDispose',
    'EvidenceSoldOrDisposeErrorHandle',
    'EvidenceSoldOrDisposeFileSectionError',
    'EvidenceSoldOrDisposeFileUploadErrorHandle',
    'EvidenceSoldOrDisposeFilesDescription',
    'EvidenceSoldOrDisposeNameField',
    'EvidenceSoldOrDisposeProvider',
    'EvidenceSoldOrDisposeSizeErrorHandle',
    'ExpiryDate',
    'FamilyNameSoldDisposed',
    'FamilyNameSomeoneElse',
    'FamilyNameYourDetails',
    'FamilyNameYourDetailsCompany',
    'FileUploadDescriptionConfig',
    'FileUploadMaxAttachmentsConfig',
    'FileUploadSizeConfig',
    'FineStage',
    'FormData',
    'FormExperience',
    'FormTypeID',
    'GivenNamesSoldDisposed',
    'GivenNamesSomeoneElse',
    'GivenNamesYourDetails',
    'GivenNamesYourDetailsCompany',
    'HEARING_DATE',
    'HearingDateRequired',
    'HasBeenNominatedBefore',
    'isDebtorTypeIndividual',
    'isOfficerIssued',
    'isThePersonNamed',
    'ID',
    'IncorrectNominationExplanation',
    'IndividualContactNumberSoldDisposed',
    'IndividualContactNumberSomeoneElse',
    'IndividualContactNumberYourDetails',
    'IndividualPostalAddressYourDetails',
    'InfringementNumber',
    'IsMarineOffence',
    'IsSeriousOffence',
    'IsSubscribedEM',
    'IsSubscribedSMS',
    'IsTsvOffence',
    'LicenceRequired',
    'LicenceStateSoldDisposed',
    'LicenceStateSomeoneElse',
    'LicenceStateYourDetails',
    'Mobile',
    'nominationConsentToDeclaration',
    'NoContactNumberSoldDisposed',
    'NoContactNumberSomeoneElse',
    'NoContactNumberYourDetails',
    'NoDriverLicenseSoldDisposed',
    'NoDriverLicenseSomeoneElse',
    'NoDriverLicenseYourDetails',
    'NoEmailSoldDisposed',
    'NoEmailSomeoneElse',
    'NoEmailYourDetails',
    'NoOrgContactNumberSoldDisposed',
    'NoOrgContactNumberYourDetails',
    'NoResidentialAddressSomeoneElse',
    'Obligations',
    'OFFENCE_DATE',
    'OffenceDateRequired',
    'OFFENCE_FIND_OUT_DATE',
    'OffenceType',
    'OrganisationContactNumberYesNoSoldDisposed',
    'OrganisationContactNumberSoldDisposed',
    'OrganisationContactNumberSomeoneElse',
    'OrganisationContactNumberYourDetails',
    'OrganisationContactNumberYesNoYourDetails',
    'OrganisationContactNumberYourDetailsCompany',
    'PartialFormID',
    'PositionInCompanyYourDetailsCompany',
    'RegistrationRequired',
    'RejectionSupportingDocs',
    'RejectionSupportingDocsDescription',
    'RejectionSupportingDocsErrorHandle',
    'RejectionSupportingDocsFileSectionError',
    'RejectionSupportingDocsFileUploadErrorHandle',
    'RejectionSupportingDocsNameField',
    'RejectionSupportingDocsProvider',
    'RejectionSupportingDocsSizeErrorHandle',
    'ResidentialAddressSoldDisposed',
    'ResidentialAddressSomeoneElse',
    'ResidentialAddressYourDetails',
    'saveEmail',
    'saveMobile',
    'submissionError',
    'submissionNo',
    'SMSRemeinderSent',
    'SaveOptions',
    'SaveYesNo',
    'SelectedGroundInfo',
    'StatecountryOfIssueSoldDisposed',
    'StatecountryOfIssueSomeoneElse',
    'StatecountryOfIssueYourDetails',
    'Status',
    'submitted',
    'TaxDriverAccNumber',
    'Tolling',
    'TransferedVicRoads',
    'UnableToIdentify',
    'UnableToIdentifyDescription',
    'UnableToIdentifyErrorHandle',
    'UnableToIdentifyExplanation',
    'UnableToIdentifyFileSectionError',
    'UnableToIdentifyFileUploadErrorHandle',
    'UnableToIdentifyNameField',
    'UnableToIdentifyProvider',
    'UnableToIdentifySizeErrorHandle',
    'VEHICLE_REGISTRATION',
    'VehicleOrIdentificationStolenOrFalse',
    'VehicleOrIdentificationStolenOrFalseDescription',
    'VehicleOrIdentificationStolenOrFalseErrorHandle',
    'VehicleOrIdentificationStolenOrFalseFileSectionError',
    'VehicleOrIdentificationStolenOrFalseFileUploadErrorHandle',
    'VehicleOrIdentificationStolenOrFalseNameField',
    'VehicleOrIdentificationStolenOrFalseProvider',
    'VehicleOrIdentificationStolenOrFalseSizeErrorHandle',
    'VictoriaPoliceReferenceNumber',
    'WasHandedInPerson',
    'WhoAreYouNominating',
    'WhoAreYouNominatingSoldDispose',
    'isABNValidSomeoneElse',
    'isACNValidSomeoneElse',
    'isABNValidSoldDisposed',
    'isACNValidSoldDisposed',
    'isABNValidYourDetails',
    'isACNValidYourDetails',
    'CanSave',
    'EmailSomeoneElseWarning',
    'IndividualContactNumberSomeoneElseWarning',
    'CompanyEmailSomeOneElseWarning',
    'OrganisationContactNumberSomeoneElseWarning',
    'EmailSoldDisposedWarning',
    'IndividualContactNumberSoldDisposedWarning',
    'CompanyEmailSoldDisposedWarning',
    'OrganisationContactNumberSoldDisposedWarning',
    'EmailYourDetailsWarning',
    'IndividualContactNumberYourDetailsWarning',
    'CompanyEmailYourDetailsWarning',
    'OrganisationContactNumberYourDetailsCompanyWarning',
  ];
  excludeKeysFromForm.forEach((value: string) => {
    delete submitObject[value];
  });
  return submitObject;
};
